export const translationJPN = {
  privacyPolicy: {
    header: '個人情報保護方針',
    downloadButton: 'Download Privacy Policy',
    subheader: '以下のプライバシーポリシーをご確認ください',
    content: {
      header: 'ピアソンのオンライン製品に関するプライバシー方針',
      description:
        '本プライバシー方針では、ピアソン関連会社（Pearson Education, Inc、Pearson Education Limited およびこちらに記載される当該会社のグループ会社）によるデータの使用方法について説明します。当社は、当社の事業全体を通じて一貫性のあるアプローチを行っていますが、お客様が利用する製品やサービスによっては異ったデータの収集や処理が行われる場合があります。そのため、当社では、当社の製品やサービスのユーザージャーニーに、本方針と一緒に読むことをお勧めするプライバシー情報（データ収集時点で行われる「ジャストインタイム通知」など）を含めることにより、<strong>当社がお客様の「個人データ」および「個人識別情報」を収集および使用する方法について、</strong>明確に理解していただけるようにしています。なお、「個人データ」および「個人識別情報」とは、人物を特定し、連絡をとり、または所在を突き止めるために単独でまたは他のデータと一緒に使用される情報（お客様の氏名、ニックネームまたはオンライン識別子など）をいいます。',
      '1': {
        question: '1. 当社について',
        paragraph1: '製品およびサービスに関する当社への連絡：',
        paragraph2: 'EU および UK のデータ保護責任者： 80 Strand, London, WC2R 0RL',
        paragraph3:
          'EU 代理人：Pearson Deutschland GmbH（住所は Kaiserstraße 44, 60329 Frankfurt am Main, Germany）',
        paragraph4Part1: '電子メール（',
        paragraph4Link: 'dataprivacy@pearson.com',
        paragraph4Part2: '）で連絡することもできます。',
        paragraph5:
          '関連製品または関連サービスに関する固有の「責任者」は、当該製品またはサービスの利用規約に記載します。英国およびヨーロッパの製品およびサービスについては、Pearson Education Limited またはPearson UK Limitedが責任者となる可能性があります。'
      },
      '2': {
        question: '2.  当社が収集する個人データ',
        paragraph1:
          '一般的に収集するデータは製品やサービスによって異なりますので、該当する製品およびサービス内でアクセスできるジャストインタイム通知および FAQ をご覧ください。',
        paragraph2:
          '特に知っておいていただきたいいくつかの処理業務があります（当該処理業務に関連する場合は、お客様にお知らせいたします）。当社は、以下の情報を収集します。',
        bullet1:
          '当社がアカウントを設定するために使用する登録情報（お客様の名前（および通称）、国、市、生年月日、電子メールアドレス、ユーザーネームおよびパスワードなど）。18 歳以上の個人については、製品またはサービスの購入に関連する情報（郵送先住所、電話番号および支払情報など）。当該情報は当社が契約を履行するために必要不可欠な情報です。性別、母国語といった情報は、任意でご提供いただける追加の登録情報です。当社は、お客様が製品やサービスにサインアップした理由を取得する場合もあります。当該情報はすべてアンケートの集約化のために使用します。',
        bullet2:
          ' 設定、インタラクティブ演習への応答、評価活動、および成果、成績またはスコアといった当社の製品やサービスを利用する過程で作成されるアクティビティ情報および利用情報。お客様は、製品やサービスに関連して発行される証明書で使用するためのプロフィール写真をアップロードすることもできます。 ',
        bullet3:
          ' お客様がアップロードする政府機関発行 ID（パスポート／運転免許証など）。お客様の氏名、写真および終了期限を抽出するために政府機関発行 ID を収集します。お客様の ID の真正性を確認するため、ならびにプロフィール作成時にお客様が当社に提供した氏名およびプロフィール写真と照合するために、お客様に写真撮影をお願いして、抽出した情報とお客様がご自身で撮影した写真とを比較します。写真との照合は人工知能を利用した顔認証テクノロジーに依拠して確実に行います。ただし、不一致が明らかになったときは、当該情報をピアソンのヒューマンレビュアチームと共有します（当社サービスへのアクセスについては、自動的な拒否は行われません）。 ',
        bullet4:
          '当社は、お客様の動画記録やお客様の画像を通じて「特別なカテゴリのデータ」を収集します。また、試験中に、口頭による応答やバックグラウンドノイズの録音も取得します。動画記録や画像の収集は、お客様の応答を収集して、お客様がスコアを受け取れるようにするために行われますが、受験している人が受験者本人かどうかを確認し、カンニングが行われないように試験を監視する目的でも行われます。また、試験での応答が、当社がお客様に関して保管しているレファレンス音声およびレファレンス写真と一致するかどうかを確認するため、ならびに試験中にカンニング警告「フラグ」が立たないようにするために、当社のサービスプロバイダが提供する人工知能を利用した顔認証および音声認証テクノロジーも使用します。上記の認証テクノロジーにはリアルタイム監視は含まれず、フラグでは試験中の顔の動きといった情動行動は追跡されません。ただし、当社がお客様に関して保有しているデータと録音が一致するかどうかについては、客観的な事前定義基準に基づいて追跡が行われます。ID における不一致はピアソンのヒューマンレビュアが検証します。また、カンニングの可能性を確認したときは、当社は、試験完了証明書を提供せず、（i）無料で再試験を実施します。（ii）お客様が明らかにカンニングを行ったことをヒューマンレビュアが確認したときは、当社は、お客様のアカウントを停止することができます。お客様は、アカウントの停止について異議を申し立てる権利を有します。当社のセキュリティ要件およびセキュリティ方針については、当社のウェブサイトをご覧ください。',
        bullet5:
          ' 記録（お客様の画像を含みます）、ならびに模擬試験中に取得されるお客様の口頭による応答およびバックグラウンドノイズ。当該情報は、お客様が試験を完了してスコアを受け取れるようにするため、および当社が模擬試験中のお客様の試験環境をシミュレートするために取得します。模擬試験中には、上記のテクノロジーを使用したお客様の身元確認やカンニング警告フラグの特定を行いませんのでご注意ください。',
        bullet6:
          ' ロケーション情報（IP アドレスを含みます）。当社では、お客様のログイン先またはログイン元の国に基づいてお客様に関連コンテンツを提供できるよう、当該情報を使用します。その他のデバイス情報および Cookie 情報（法律で要求される場合はお客様の許可を取得します）、ログインデータ、ならびにデバイス情報も、より適切なパーソナライズコンテンツをユーザーであるお客様に提供するために収集します。詳細については、製品またはサービスへのアクセス時に提供される Cookie 方針をご覧ください。 ',
        paragraph3:
          '試験中に照合を行うために当社が当社のサービスプロバイダの人工知能を利用する場合、当該サービスプロバイダは、自社のテクノロジーを改善する目的でお客様に関して取得したデータを使用する場合があります。上記の活動が実施される場合は、当該サービスプロバイダから指針が提供されます。サービスプロバイダによる使用には、当該サービスプロバイダのプライバシー通知が適用され、当社は当該プライバシー通知へのリンクを掲載します。'
      },
      '3': {
        question: '3. 個人データを収集する目的および法的根拠',
        paragraph1:
          'アカウント登録の円滑化、お客様との連絡、マーケットリサーチおよびサービスの改善、お客様の経験のパーソナライズ、第三者テクノロジとの統合管理、法律および規則の遵守、ならびに当社が保有する法的権利の防御および行使のいずれであるかを問わず、最終的に、当社は、当社の製品やサービスの使用の際に可能な限り最高の経験を提供し、お客様の生涯学習を支援するために個人データを収集します。 以下に収集の根拠を記載します。',
        bullet1:
          '<strong>契約の履行</strong>（お客様が購入またはアクセスした製品／サービスを提供するためなど）。',
        bullet2:
          ' お客様の<strong>同意</strong>（18 歳以上のお客様の行うマーケティング活動に対する同意など）。当該同意はいつでも取り消すことができます。',
        bullet3:
          '<strong>法的義務</strong>の遵守（当社は、規制上の報告義務または情報共有義務を負う場合があります）。',
        bullet4:
          '教育製品や教育サービスの商業プロバイダである当社の<strong>正当な利益</strong>に該当する様々なビジネス上の目的（ジャストインタイム通知を通じてサービスごとに詳細に記載します）',
        paragraph2:
          '当社が要配慮個人データ／特別なカテゴリの個人データ（バイオメトリクスデータまたは健康データなど）を処理するには、<strong>重要な公共の利益</strong>（不正行為やカンニングの防止）、および追求する目的に適した法律の存在、またはお客様の同意といった追加の法的根拠が必要です。'
      },
      '4': {
        question: '4. 当社が情報を収集する場合',
        paragraph1: '当社は、主に次の 3 つの方法でお客様の情報を収集します。',
        bullet1:
          '<strong>直接</strong>収集する場合。製品やサービスの利用登録、当社への連絡（オンラインかオフラインかを問いません）、または当社の製品やサービスに関するサブスクリプションの購入などの際に、お客様（またはお客様の親／保護者）から提供される情報を直接収集します。',
        bullet2:
          '<strong>直接</strong>収集する場合。お客様が製品やサービスとやり取りした場合、または当社からの電子メールを利用した場合は、直接情報を収集します。',
        bullet3:
          '所定の第三者から<strong>間接的に</strong>情報を収集します。間接的な収集は、製品やサービスによって異なりますので、ユーザージャーニーに記載する個別のステートメントをご覧ください。当該情報には、学校／類似の教育機関からの情報も含まれます（お客様が当社の製品やサービスのいずれかにアクセスするためのスクールアクセスコードを保有している場合）。また、お客様が認証目的で Google アカウントを使用してサインアップしている場合は、Google からの情報も収集対象に含まれます。当社は、郵送先住所またはクレジットカード情報の確認目的を含む、当社が収集した情報の更新、確認、または当該情報への追加を行うために、第三者からお客様のデータを収集することがあります。',
        paragraph2:
          '<strong>注記：</strong>当社の製品やサービスには、未成年者（当社の定義に基づく 18 歳未満の個人）向けの製品やサービスが含まれる場合があります。かかる場合、当社は、未成年者にも理解できる方法で当社のデータ処理に関する情報を提供します。または親／保護者に対して、未成年者に代わってサインアップする際に関連事項を説明するようお願いしています。'
      },
      '5': {
        question: '5. お客様の個人データまたは個人識別情報の保存期間',
        paragraph1:
          '当社は、お客様の個人データの処理目的を実施するために合理的に必要な期間、お客様の情報を保存します。データは、お客様が当社の製品やサービスを使用する全期間、および使用期間終了後の合理的な期間、保存することができます（一般的には、アクティビティがない状態から 1 年くらい。当社は、アクティビティがないときは、6 ヵ月後にアカウントが削除されることをユーザーに電子メールで連絡します）。保存期間がこれより短い場合もあります。例えば、当社が特定の画像や音声を保存するのは、試験完了後 6 ヵ月間です。法律が要求する場合、当社はそれより長い期間、データを保持します。例えば、請求書および特定の支払情報は、6 年に、関連する請求書発行年度を合計した期間、保持します。保存期間は製品やサービスによって異なりますので、該当する製品およびサービス内でアクセスできる FAQ をご覧ください。 ',
        paragraph2:
          '可能な場合、当社は、学習者のタイプや当社の製品やサービスの使用方法の分析、戦略的開発の支援、教育リサーチの実施、新製品や新サービスの開発、および既存の製品やサービス改善のために、個人情報を匿名化します（匿名化により、直接または間接的にも個人学習者の特定はできなくなります）。'
      },
      '6': {
        question: '6. 開示および移転',
        paragraph1: 'グループ会社への開示',
        paragraph2:
          '当社は、当社の製品やサービスの新たな機能を分析、テストおよび開発できるようにするために、個人データや個人識別情報をピアソン関連会社に属する他の会社に開示する場合があります。当社は、（法律が要求する場合は）お客様の同意を条件として、ピアソン関連会社とお客様の個人情報を共有して、ピアソン関連会社が当社のグループ会社が提供する関連製品やサービス（お客様が関心を持つと考える製品やサービスのみ）をお客様にお知らせできるようにする場合があります。',
        paragraph3: '企業、パートナーおよび信頼のおける組織への開示',
        paragraph4:
          '当社は、特定の製品やサービスについて、スタッフや学習者にサービスを提供している雇用主および教育機関と密接に連携しています。上記の雇用主および教育機関は、お客様の個人データを管理者として処理することについて独自のプライバシ通知を保有している可能性がありますので、必ず当該プライバシ通知を要求して、読むようにしてください。 ',
        paragraph5: 'その他の開示',
        paragraph6:
          '以下の状況に該当する場合、当社は、個人データまたは個人識別情報を開示する場合があります。',
        bullet1:
          'データセンター、ウェブホスティングプロバイダ、クラウドストレージプロバイダ、クラウドソフトウェアプロバイダ、カスタマーサポートプロバイダ、支払処理業者、債権回収者、会計士、および保険会社など、当社が外部のプロバイダおよびデータ処理者とデータまたは情報を共有するとき。',
        bullet2:
          ' 当社が、当社の事業または資産の潜在的な売主または買主（投資家の各専門アドバイザおよび当社の専門アドバイザを含みます）とデータまたは情報を共有するとき（当社が財政困難を経験する場合を含みます）。 ',
        bullet3:
          '18 歳未満の学習者に関し、当該学習者に代わって製品やサービスへのアクセスを購入した親／保護者の同意があるとき。',
        bullet4:
          ' データの共有についてお客様が当社に同意を提供したとき、またはお客様が共有を要請したとき（例えば、試験完了を確認する証明書を雇用主および／または教育機関に送付するようお客様から要請があった場合、またはバーチャルクラスの一環として、評価に関するフィードバックをお客様が提供できるようにする場合など。ユーザーはデータの共有をいつでも取り消すことができます）。',
        bullet5:
          ' 法執行措置、法令遵守または契約遵守、および報告の目的で、規制機関、法執行機関、裁判所および関連当事者との共有が必要または求められたとき。 また、当社の利用規約を実施し、お客様および他者の安全を確保し、ならびに当社または他者の権利および財産を保護するためにも、共有を行います。',
        paragraph7: 'データの移転',
        paragraph8:
          '当社は、グローバル組織の一員であり、グローバルサービスプロバイダを利用しています。したがって、お住まいの国以外の国でデータの処理および共有が行われる場合があります。ただし、当社は、現地法に従ってのみ、かかる処理および共有を行い、適切な措置を講じることにより、適用されるデータ保護法が要求するのと同じ保護基準に基づいてデータの受領が行われるようにしています。',
        paragraph9:
          '欧州連合または英国にお住まいのお客様の場合、当社は、（a）こちらに記載する個人データに関して十分なレベルの保護が提供されていると欧州委員会がみなす国に対してのみ（英国においても同等の条件）、および／または（b）欧州委員会および情報コミッショナーオフィスが承認した、当該個人データに対して上記と同様の保護を提供する特定の契約を当社が保有している場合に限り、お客様の個人データを移転します。'
      },
      '7': {
        question: '7.  お客様が保有する権利',
        paragraph1:
          'お客様は、ご自身の個人データに関し、お住まいの国に応じて異なる権利を保有する場合があります。 ',
        paragraph2: '欧州連合または英国にお住まいのお客様： ',
        paragraph3:
          '<strong>処理に異議を申し立てる権利。</strong>お客様は、当社が正当な根拠に依拠して行う個人データの処理について、いつでも異議を申し立てることができます。お客様から異議の申し立てがあった場合、当社は、お客様の利益、権利および自由に優先するやむをえない正当な根拠を証明しない限り、または法的請求の証明、実施もしくは防御のために当社が個人データを処理する必要がある場合を除き、処理を中止しなければなりません。当社が処理の根拠として依拠するのが正当な利益である場合、当社は、やむをえない正当な根拠を証明できると考えていますが、そうした場合でも、個々の事案を個別に検討します。 また、お客様は、ダイレクトマーケティング目的で行われる個人データの処理に対して、いつでも異議を申し立てることができます。お客様から異議の申し立てがあった場合、当社は処理を中止します。',
        bullet1:
          '<strong>アクセス権</strong>。お客様はご自身の個人データのコピーを提供するよう当社に要請することができます。コピー提供の要請にはいくつかの例外があります。すなわち、お客様は、当社が処理する情報のすべてを常に受け取れるわけではありません。要請した情報に他者に関する個人データが含まれる場合などは、例外となります。',
        bullet2:
          ' <strong>修正権</strong>。お客様は、正確でないと考える情報を修正するよう当社に要請することができます。また、お客様は、不完全であると考える情報を完全な情報にするよう当社に要請する権利も有しています。 ',
        bullet3:
          '<strong>消去権</strong>。お客様は、特定の状況下において、ご自身の個人データを消去するよう当社に要請することができます。',
        bullet4:
          '<strong>処理を制限する権利</strong>。お客様は、特定の状況下において、ご自身の情報の処理を制限するよう当社に要請することができます。',
        bullet5:
          '<strong>同意を撤回する権利</strong>。当社が同意に依拠してお客様の個人データを処理している場合でも、お客様はいつでも当該同意を撤回することができます。同意が撤回されても、同意の撤回前に実施した処理の適法性に影響が生じることはありません。',
        bullet6:
          '<strong>データポータビリティ権</strong>。データポータビリティ権は、お客様が当社に提供した情報のみに適用されます。お客様は、提供した情報をある組織から別の組織に移転するよう、またはお客様に提供するよう当社に要請することができます。データポータビリティ権は、当社が契約の履行および／またはお客様の同意を根拠に情報を処理している場合にのみ適用されます。',
        paragraph4:
          '権利行使に際して何らかの手数料を支払う必要はありません。ただし、根拠のない、繰り返される、または過剰な請求の場合、当社は、合理的な手数料を請求できるものとします。当社のお客様への回答期限は 1 ヵ月とします（ただし、お客様が多数の請求を行った場合、または請求が複雑な場合、当社は、回答期限を最大で 2 ヵ月間延長することができます。かかる場合、当社からお客様にお知らせします）。当社がお客様に身元確認の証拠を要請した場合、1 ヵ月の回答期限は当社が当該証拠を受領するまで開始しないものとします。当社が要請の範囲について説明を求めた場合、1 ヵ月の回答期限は、当社が説明に関する情報を受領するまで停止します。',
        paragraph5:
          'また、お客様は、お住まいの地域の当局を含む監督当局に対して、いつでも不服申し立てを行う権利を有します。もちろん、監督当局に働きかける前に、お客様の懸念事項に対処する機会をいただければ幸いです。',
        paragraph6:
          'カリフォルニア州にお住まいのお客様は、本プライバシ通知とあわせて、カリフォルニア州居住者の個人情報の取り扱いを定めたカリフォルニア州法の遵守に関する当社の取り組みについて説明する、カリフォルニア州居住者向けの補足プライバシステートメントをお読みください。'
      },
      '8': {
        question: '8. 本プライバシ方針の変更',
        paragraph1:
          '当社は、本方針または当社の固有のステートメントを随時更新する場合があります。当社では、いつ変更が行われたかを確認していただけるように、常に最新バージョンの日付を記載しています。法律が要求する場合、重大な変更をお客様にお知らせいたします。',
        paragraph2: '本方針の最終更新日は、2022 年 12 月 6 日です。'
      }
    }
  },
  termsOfUse: {
    header: '利用規約',
    downloadButton: '利用規約のダウンロード',
    subheader: 'ユニバーサルサービス規約とエンドユーザーライセンス契約の確認',
    preSection: {
      header: 'ユニバーサルサービス規約およびエンドユーザーライセンス契約書',
      paragraph1:
        '「承諾する」もしくは「同意する」をクリックするか、または本 サービスを利用することにより、お客様は、ユニバーサルサービ ス規約およびエンドユーザーライセンス契約（以下「本 UTOS」） を締結したことになります。本 UTOS は、Pearson Education, Inc. または当社が代理する当社の関係会社（以下総称して「当社」 または「ピアソン」）との間の拘束力のある契約となります。',
      paragraph2:
        '本 UTOS には、本ウェブサイトおよび関連するすべての本サービスの利用に適用される一般条 件が記載されています。本サービスにアクセスするか本サービスを利用することにより、お客 様は、本 UTOS の条件に同意し、以下のすべてを表明したことになります。（1）規約を読み、 理解したこと。（2）本 UTOS、適用されるすべての地方、州、国および国際レベルの法律およ び規則、ならびにお客様の教育機関の学則または方針を遵守した本サービスの利用に同意する こと。（3）承認ユーザーであること。お客様が本 UTOS に同意しない場合または承認ユーザー でない場合は、本サービスを利用できません。本 UTOS についてのご質問は、当社（<a href="https://support.pearson.com/getsupport/">ピアソン サポート</a>）までご連絡ください。',
      paragraph3:
        '条項の見出しおよび以下に記載されているイタリック体の要約は、便宜のためにのみ記載されており、法的な意味や効力を有しません。'
    },
    content: {
      '1': {
        question: '1. データプライバシー、収集および使用',
        paragraph1:
          'ピアソンによるデータの収集および本サービスに関する使用慣行は、各本サービスに適用されるプライバシー通知で説明されています。当社は、適用されるプライバシー通知および法令に従って、お客様の個人情報を収集、処理および使用します。'
      },
      '2': {
        question: '2. 時折行う必要のある本 UTOS の変更',
        paragraph1:
          '時折、本 UTOS の規則を更新しなければならない場合があります。有意義な変更を行う 場合はお客様にお知らせいたします。本サービスの使用を継続することにより、お客様 は、更新後の規則に従うことに同意したことになります。',
        paragraph2:
          'ピアソンは、理由を問わず随時本 UTOS を更新することができます。一般的に本 UTOS の変更は、変更される規制上の要件に現在の慣行を一致させて当該要件を遵守するた め、または類似する他の目的のために行われます。お客様に提供する本サービスの条件 または範囲を大幅に変更する形でピアソンが本 UTOS を変更する場合（以下<strong>「本サービ スの変更」</strong>）、当社は、そのような変更に留意していただくため、相当な努力を尽くし て、電子メールの送信、または本サービスに関連する合理的な通知を掲示して、お客様 にお知らせいたします。本 UTOS の変更に関する合理的な通知の提供後に本サービスの 利用を継続した場合、お客様は、改訂後の本 UTOS の条件に同意したものとみなされま す。この場合、合理的な通知後に行われる本サービスの使用には改訂後の条件が適用さ れます。本サービスの変更によって重大な影響が生じるとお考えになる場合は、（1） 変更通知の受領後 30 日以内にその旨をピアソン（<a href="https://support.pearson.com/getsupport/">ピアソンサポート</a>）に通知する必要 があります。お客様は、その後（2）本サブスクリプションおよび本サービスの利用を 終了することができます。本 UTOS についてのご質問は、当社（<a href="https://support.pearson.com/getsupport/">ピアソンサポート</a>）ま でご連絡ください。'
      },
      '3': {
        question: '3. 本サービスの利用ライセンス',
        paragraph1:
          'ご自身の個人的な教育目的（本 UTOS で認められる目的）のために、本サブスクリプシ ョンが終了するまで、本サービスの特徴や機能を利用し、お楽しみください。',
        paragraph2:
          'ピアソンは、本 UTOS、<a href="https://loginstatic.pearson.com/html/AcceptableUsePolicy.html">AUP</a>、適用されるプライバシー通知、およびお客様の教育機関 または第三者サービスが定める追加規約の条件および制限に従い、本サービスが意図す る目的で本サービスを利用することができる、限定的、譲渡不可、非独占的およびサブ ライセンス不可のライセンスをお客様に付与します。',
        paragraph3:
          'お客様は、本サービスを通じて取得した本マテリアルを、ご自身の個人的かつ非営利的な教育目的に限り、使用および表示し、ならびに本サービスで機能が提供されている場合は、リフォーマット、ダウンロード、および印刷することができます。',
        paragraph4:
          'お客様は、本サービスの適切な利用およびアクセスに必要となる、その時点のハードウ ェア、オペレーティングシステム、インターネットブラウザ、およびその他の技術要件 を満たす責任を負います。本契約で明示的に付与されていないすべての権利はピアソン が留保します。お客様は、本 UTOS の下で付与されるライセンスに基づき本サービスま たは本サービスに含まれる本マテリアルの権原または所有権は提供されないこと、提供 されるのは本 UTOS に従った限定利用権のみであることを了解します。'
      },
      '4': {
        question: '4. 「本サービス」とは',
        paragraph1:
          '「本サービス」とは、ピアソンのウェブサイト、デジタル製品、ならびに当該ウェブサイトおよび当該製品を機能させるすべてのものを意味します。本サービスを所有しているのはピアソンまたは当社のライセンサです。本規則に従って本サービスの利用をお楽しみください。',
        paragraph2:
          '本ウェブサイト、ならびに本ウェブサイトに関連するアプリケーション、製品、サービス、テクノロジ、コンテンツ、およびその他の知的財産（以下総称して<strong>「本サービス」</strong>）は、ピアソンもしくは当社のライセンサが所有するか、またはピアソンもしくは当社のライセンサによってライセンスされています。本サービスを通じて提供されるすべてのウェブサイト、教材、およびその他のコンテンツ（以下総称して<strong>「本マテリアル」</strong>）、ならびに支援ソフトウェア、アプリケーション、およびシステム（以下総称して<strong>「本アプリケーション」</strong>）は、ピアソンおよび／または当社のライセンサの独占的財産です。本サービスは、お客様のブラウザやアプリ（モバイルその他等）を利用してインターネット配信される場合があります。また、本サービスを通じて提供される、お客様の学校、雇用主、大学、またはその他の教育機関（以下<strong>「教育機関」</strong>）が提供するク ラスやプログラム関連の利用を目的とした 1 または複数のオンラインコース（以下<strong>「本コース」</strong>」）では、本サービスの中に本コースへの受講登録（以下<strong>「受講登録</strong>」）が含まれる場合があります。お客様がお持ちのユーザーアカウントが、他の本コースに登録する可能性のある期間中は不特定期間の継続を認めるものである場合、本サービスを通じた特定の本コースへのアクセスは、期間限定のサブスクリプションベースで提供されます（以下それぞれを<strong>「本サブスクリプション」</strong>）。本サービスは、ピアソンが直接提供する場合、またはお客様の教育機関もしくは第三者の統合サービスプロバイダが管理する統合第三者アカウントを通じてアクセスできる場合があります（以下<strong>「第三者サービス」</strong>）。本サービスで、第三者のウェブサイトもしくはアプリケーションへのリンクが提供される場合、またはリンク先へのアクセスオプションが提供される場合があります。'
      },
      '5': {
        question: '5. 本サービスの利用が認められる人',
        paragraph1:
          '特定の本サービスを利用するには、ピアソンアカウントを作成する必要があります。ただし、未成年者の場合は、大学に入学するまで、アカウントを作成したり、ご自身で登録したりすることはできません。',
        paragraph2:
          '本サービスは、個人に対してのみ提供されます。ここでいう個人には、本サービスへの適法なアクセスを、ピアソンもしくは第三者のサービスプロバイダから直接取得しているか、または当該個人に関係する教育機関を通じて取得している、教育機関の管理者またはその他の担当者、および学生等が含まれます（以下<strong>「承認ユーザー」</strong>）。特定の本サービスにアクセスするには、お客様の名前、姓、有効な電子メールアドレス（および受講登録の場合は、お客様の教育機関および本コースの名称または本コースのコード）を提供し、秘密かつ固有のユーザーネームおよびパスワードを指定し（以下<strong>「アカウント認証情報」</strong>）、さらにお客様の教育機関から要求される追加情報を提供して、ユーザーアカウント（以下<strong>「ユーザーアカウント」</strong>）の登録を行うよう求められる場合があります。お客様の教育機関により、または学習管理システムなどの統合第三者サービスから直接アクセスする方法により、お客様のユーザーアカウントがすでに開設されている場合もあります。このような場合は、当該教育機関または第三者サービスが追加の利用規約またはアカウントアクセス要件を保有している可能性があります。ピアソンは、本サービスへのアクセスがあった場合は、その都度アカウントの有効性を検証する目的で、本サービスを提供する前にお客様のアカウント認証情報を使用する場合があります。',
        paragraph3:
          '特定時点でお客様が保有できるアクティブなユーザーアカウントは 1 つのみです。お客 様は、ユーザーアカウントを作成する際には、正確で真実な情報を提供し、変更があっ た場合は速やかに情報を更新することに同意します。',
        paragraph4:
          '13 歳未満のお客様は、ご自身で本サービスに登録したり、本サービスにアクセスしたり することはできません。ただし、お客様の親または法定後見人がお客様に代わってアカ ウントを開設または登録している場合は、この限りではありません。お住まいの法域の 法律に基づく成人年齢に達していないお客様（通常は 18 歳未満のお客様）は、まずご 自身の親または保護者の許可を得てからでないと、本サービスに登録したり、本サービ スを利用したりすることはできません。未成年者であるお客様に代わって親または法定 後見人がユーザーアカウントの登録または開設を行う場合、ピアソンとの契約は、お住 まいの法域の該当する成人年齢に達するまでの間、お客様の親または後見人がお客様を 代理して締結します。当該契約は、お客様が成人年齢に達した時点でお客様に移転しま す。ただし、適用される成人年齢未満のお客様でも高等教育機関に入学している方は、 本サービスにご自身で登録することができます。',
        paragraph5:
          'ピアソンは、自己の単独かつ絶対的な裁量により、お客様のユーザーアカウントを停止 または終了する権利を留保します。お客様に本 UTOS 違反または <a href="https://loginstatic.pearson.com/html/AcceptableUsePolicy.html">AUP</a> 違反があった場 合、本サービスを利用する、または本サービスにアクセスするお客様の権利は自動的に 終了します。さらに、ピアソンは、時期を問わず、本サービスの全部または一部の継続 を一時的または永久的に停止する権利を留保します。'
      },
      '6': {
        question: '6. 本サービスの妥当な利用',
        paragraph1:
          '本サービスの利用には、ピアソンの<a href="https://loginstatic.pearson.com/html/AcceptableUsePolicy.html">利用規定</a>（以下「<strong>AUP</strong>」）が適用されます。本サービスにアクセスするかまたは利用 （以下「<strong>AUP</strong>」）が適用されます。本サー ビスにアクセスするかまたは利用することにより、お客様は、<strong>AUP</strong> の規定を遵守するこ とに同意したことになります。ピアソンは、以下のいずれかが発生した場合、自己の単 独の裁量に基づいて本サービスへのアクセスおよび利用を停止または終了する権利を留 保します。いずれかのユーザーが <strong>AUP</strong> の規定に違反する活動を実施した、もしくはその ような活動に参加したとピアソンが合理的に考える場合、またはいずれかのユーザーの 活動によってピアソン、本サービス、本サービスネットワーク（<strong>AUP</strong> で定義）もしくは 他のユーザーに被害が生じた、もしくは生じる可能性があるとピアソンが合理的に考え る場合（ピアソンは、当該ユーザーに関するアクセスおよび利用を停止または終了しま す）、あるいはピアソンの単独かつ絶対的な裁量に基づくその他の事由が発生した場 合。さらに、ピアソンは、お客様の教育機関からの要請に応じて、いつでもお客様のア クセスを停止または終了することができます。'
      },
      '7': {
        question: '7. アカウント認証情報の秘密かつ安全な保持',
        paragraph1:
          'お客様は、（1）アカウント認証情報を秘密保持すること、（2）お客様のユーザーアカウントへのログインを他者に許可しないこと、および（3）誰かがお客様のアカウント認証情報を入手した場合は当社に知らせることに同意します。',
        paragraph2:
          'お客様のユーザーアカウントは、お客様ご自身による使用のみを目的としています。当社から承認メカニズムが提供されない限り、ご自身のユーザーアカウントの使用を許可して他者に本サービスへのアクセスや利用を提供することは固く禁じられています。ご自身の利用か第三者による利用かを問わず、お客様は、お客様のユーザーアカウントに関連する本サービスのあらゆる利用について責任を負います。',
        paragraph3:
          'アカウント認証情報および本サービスのセキュリティを保護するには、お客様がご自身のアカウント認証情報を秘密保持することが重要です。お客様は、以下に同意します。（1）ご自身のアカウント認証情報以外の認証情報を使用しない。または（2）ご自身のアカウント認証情報を、第三者または承認を受けた第三者サービス以外のサービスに開示しない。お客様は、合理的な措置を講じてご自身のアカウント認証情報の秘密を保護するとともに、アカウント認証情報および／または本サービスに関連して取得したアクセスコードの紛失、開示または盗難に気づいたかまたはそのような事態が生じたと考える場合は、直ちにピアソン（<a target="_blank" href="https://pearson.tfaforms.net/3048">ピアソンサポート</a>）に通知することに同意します。'
      },
      '8': {
        question: '8. ピアソンまたは当社のライセンサによる本サービスの所有',
        paragraph1:
          '本サービスおよび関連するすべての知的財産を所有しているのは当社または当社のライ センサです。本 UTOS の説明に従ってこれらの利用をお楽しみください',
        paragraph2:
          '本サービスを通じて提供されるすべてのウェブサイト、教材、およびその他のコンテン ツ（以下総称して<strong>「本マテリアル」</strong>）、ならびに支援ソフトウェア、アプリケーショ ン、およびシステム（以下総称して<strong>「本アプリケーション」</strong>）は、ピアソンおよび／ま たは当社のライセンサの独占的財産であり、米国および国際的な著作権法およびその他 の知的財産法によって保護されています。本書で明示的に付与されていないすべての権 利は留保されています。本 UTOS または <a href="https://loginstatic.pearson.com/html/AcceptableUsePolicy.html">AUP</a> に定める場合を除き、本マテリアルまた は本アプリケーションの全部または一部の複製、再配布、修正、公表または翻案は、ピ アソンおよび／または当社のライセンサが書面で明示的に同意しない限り、固く禁じら れています。本サービスによって特定のマテリアルのコピーやダウンロードが許可され ることがありますが、このような機能が利用できるからといって、上記の制限が適用さ れないことにはなりませんのでご注意ください。',
        paragraph3:
          '別段の指示がない限り、本サービスで表示される商標、サービスマーク、および商品名（総称して<strong>「本マーク」</strong>）は、ピアソンまたは当社のライセンサの財産です。本サービスで表示されているがピアソンが所有していない商標は、当該商標の各所有者の財産です。お客様は、本サービスに関係する本マークを不正に使用したり、その評判を傷つけたりしないこと、あるいは本マーク（または混同を引き起こす可能性のある類似のマーク）を、所有権の不実表示に該当するような方法、または製品やサービスの出所もしくは原産地に関して公衆が誤認する可能性がある方法で使用しないことに同意します。お客様は、以下のすべての要件を満たさない限り、本マークを使用してはなりません。本マークの所有者から書面による同意を取得すること、当該所有者の商標権に関する適切な通知および帰属表示を使用すること、および本マークの各所有者が提供する適用される利用ガイドラインに従って本マークを使用すること。お客様による本マークの許可される使用は、本マークの各所有者の利益のために行われるものとします。'
      },
      '9': {
        question: '9. ユーザー提案のピアソンによる所有',
        paragraph1:
          'お客様から本サービスの改善に関する提案があった場合、ピアソンは、当該提案に含まれるすべての知的財産権を所有し、報酬の支払いなくお客様のアイデアを使用することができます。',
        paragraph2:
          'ピアソンは、いつでも本サービスに関する提案やご意見を歓迎いたします。改善、追加の提案、またはそれ以外のご意見等は、本サービス、オンライン、オフライン、口頭、または書面でピアソンに提出することができます（以下「<strong>ユーザー提案</strong>」）。提出方法にかかわらず、お客様は、ユーザー提案に含まれるすべての権利、権原、権益およびその他の知的財産権（日本の著作権法、第二十七条および第二十八条に記載されている権利を含みますが、これらに限定されません）がピアソンの単独の財産となること、ならびにピアソンの単独かつ絶対的な裁量に基づいて、お客様への支払いまたは説明なく、ユーザー提案に含まれる権利等がピアソンの事業目的のために使用される場合があることを了解します。この規定は、ピアソンが開発した製品およびサービスが他者からみてユーザー提案と類似していると思われる場合に生じる可能性のある、将来の誤解を避けるためのものです。'
      },
      '10': {
        question: '10. 当社によるアップロードコンテンツの使用方法',
        paragraph1:
          'お客様は、本サービスにお客様がアップロードしたコンテンツを当社が使用できること（もちろん適用されるプライバシー通知および法令に従って使用します）、およびお客様が当社にアップロードコンテンツの使用権を付与する権限を有していることに同意します。',
        paragraph2:
          '本サービスにより、承認ユーザーが、質問、応答、コメント、アイデア、記事、情報、 データ、テキスト、マルチメディアコンテンツ、チャットの会話もしくはログ、メッセ ージ、およびその他のマテリアルまたは提出物（以下「<strong>ユーザーコンテンツ</strong>」）を作 成、アップロード、または投稿できる機能が提供される場合があります。ユーザーコン テンツを作成、投稿、アップロードするか、またはユーザーコンテンツへのリンクを提 供することにより、お客様は、当該ユーザーコンテンツ、および当該コンテンツから作 成される本サービスに関連した二次的著作物（本サービスにとってよりふさわしいもの になるように当社が変更を加えたコンテンツなど）を使用、ホスト、ライセンス、保 管、複製、表示、送信、翻案、および配布することができる、永続的、ロイヤリティ無 償、全世界で有効な権利およびライセンスをピアソンに付与したことになります。さら に、お客様は、お客様のユーザーコンテンツは、本 UTOS および特に本第 <strong>10</strong> 条に従っ て、お客様がピアソンに付与したものと同じ条件に基づいて他のユーザーにも提供され ることを了解し、同意します。ピアソンは、ユーザーコンテンツの削除、破壊、損害、 損失、または保管の懈怠について責任を負わず、または責任を問われないものとしま す。第三者所有のユーザーコンテンツを投稿することにより、お客様は、ピアソンが当 該ユーザーコンテンツをユーザーに提供できるよう（本サービスで提供される本マテリ アルと同じ範囲でユーザーに提供できるよう）、かかる権利をすでに取得済みであるこ とを表明したことになります。お客様は、お客様または第三者が著作権を主張するユー ザーコンテンツについて、適切な著作権表示を提供することに同意します。追加の条件 およびオプションは、本サービスで提供されるユーザーコンテンツを投稿またはアップ ロードするためのユーザーインターフェイスを通じて提示されます。当該条件およびオ プションは、本 UTOS を補完するものであり、本 UTOS の規定と同様の効力および効果 を有します。'
      },
      '11': {
        question: '11. 自己責任で行う第三者のウェブサイトやコンテンツへのアクセス',
        paragraph1:
          '本サービスがピアソン以外のウェブサイトやサービスにリンクしている場合、または本サービスによってお客様が当該ウェブサイトやサービスに転送される場合、お客様は、当該ウェブサイトおよびサービスの利用を自己責任で行うことに同意します。',
        paragraph2:
          'お客様が第三者のウェブサイトから本サービスにリンクを張っている場合、および／ま たは本サービスからピアソンの管理が及ばない他の第三者のウェブサイトやリソースへ のリンクが提供される場合があります（以下総称して<strong>「第三者サイト」</strong>）。ピアソン は、本サービス上の第三者サイトへのリンクを介してアクセスできる第三者のコンテン ツ（以下<strong>「第三者コンテンツ」</strong>）、サービス、またはアプリケーションについては、い かなる責任も負いません。ピアソンは、第三者サイトまたは第三者コンテンツの正確 性、完全性、または品質について推奨や保証を行うことはなく、当該コンテンツまたは サイトに起因するエラー、欠落、第三者の権利に対する違反、または違法行為について のあらゆる責任を否認します。本サービスに第三者サイトへのリンクが含まれていて も、第三者サイトの所有者が本サービスを支援または推奨していることにはなりませ ん。ピアソンは、本サービスからのリンクを通じてアクセスする第三者サイトの利用可 能性について責任を負いません。また、当該第三者サイトには、本 UTOS またはピアソ ンの他の利用規定は適用されません。第三者サイトへのリンクが機能しなくなったこと に気づいたお客様は、当社（<a href="https://support.pearson.com/getsupport/" target="_blank">ピアソンサポート</a>）までご連絡ください。不適切なコンテ ンツまたは禁止ユーザーコンテンツをユーザーに送信するリンクは、当社 （<a href="mailto:pearsondmca.agent@pearson.com">pearsondmca.agent@pearson.com</a>）に報告してください。'
      },
      '12': {
        question: '12. DMCA 通知の提出方法',
        paragraph1:
          '本サービスを通じて提供されるコンテンツについて著作権に関する懸念をお持ちのお客 様、または DMCA 通知を提出したいとお考えのお客様は、以下の詳細な指示をお読みく ださい。',
        paragraph2:
          '他者が本サービス上で投稿したマテリアルについて著作権に関する懸念をお持ちのお客 様、または本サービス上の不適切なコンテンツを報告したいとお考えのお客様は、当社 までお知らせください。当社は、インターネットサービスプロバイダに適用されるデジ タルミレニアム著作権法（<strong>17 U.S.C.</strong> 第 <strong>512</strong> 条）の規定を遵守しています。ピアソンか ら提供される特定の <strong>DMCA</strong> 選任書に別段の記載がない限り、以下の住所の当社指定代理 人に連絡する方法で、当社まで書面通知（以下<strong>「本通知」</strong>）を提出してください。',
        paragraph3: 'DMCA 代理人',
        paragraph4: 'Pearson Education, Inc.',
        paragraph5: '221 River Street',
        paragraph6: 'Hoboken, NJ 07030',
        paragraph7:
          '電子メール: <a href="mailto:pearsondmca.agent@pearson.com">pearsondmca.agent@pearson.com</a>',
        paragraph8:
          '著作権保護著作物が本サービスを通じて著作権侵害に該当する方法でコピー、翻案、複製または展示されていると誠実に信じる、著作権所有者または著作権所有者の授権代理人であるお客様は、当社指定代理人に侵害行為を申し立てる書面通知を提出することができます。有効な通知となるには、本通知に以下のすべてを記載しなければなりません。',
        bullet1:
          '侵害を申し立てる排他的権利の所有者、または当該所有者の授権代理人として行為する者（以下<strong>「申立当事者」</strong>）の実署名または電子署名。住所、電話番号、および利用可能な場合は電子メールアドレス等、ピアソンが申立当事者に連絡をとるために合理的に十分な情報。',
        bullet2:
          '申し立てる本サービス上の侵害マテリアル（以下<strong>「侵害マテリアル」</strong>）の説明、および侵害マテリアルが本サービス上のどこに掲載されているかをピアソンが突き止めることができる合理的に十分な情報。本サービス上で侵害を受けたと申し立てる著作権保護著作物（以下<strong>「被侵害マテリアル」</strong>）の説明、または本サービス上の複数の著作権保護著作物を 1 つの本通知に記載する場合は、侵害を申し立てる各著作権保護著作物のリスト（被侵害マテリアルを侵害している侵害マテリアルを個別に記載すること）。',
        bullet3:
          '申し立てる方法での侵害マテリアルの使用が、著作権所有者、そのエージェント、または法律が許可する使用でないことを申立当事者が誠実に確信している旨を記載した陳述書。',
        bullet4:
          '本通知の情報が正確であること、および偽証罪の適用を認識したうえで行われる、申立当事者が侵害を申し立てる排他的権利の所有者または当該所有者の授権代理人であることを記載した陳述書。'
      },
      '13': {
        question: '13. その他の禁止コンテンツの報告方法',
        paragraph1:
          '本サービスで、侵害コンテンツ、不快なコンテンツ、または本 UTOS もしくは AUP で 禁止されるコンテンツを発見した場合は、当社まで通知してください。当社が当該コン テンツを放置しておくことはありません。',
        paragraph2:
          'ピアソンでは、禁止ユーザーコンテンツの通報も推奨しています（<a href="mailto:pearsondmca.agent@pearson.com">pearsondmca.agent@pearson.com</a>）。ピアソンがかかる問題に迅速に対応できるよ う、お客様の電子メールに以下の事項を記載してください。問題が発生しているピ）。ピアソンがかかる問題に迅速に対応できるよ う、お客様の電子メールに以下の事項を記載してください。問題が発生しているピアソ ンページの URL。リンク先ページの URL。該当するコンテンツの説明、および当該コン テンツが禁止コンテンツまたは不適切なコンテンツであると信じる根拠。調査の際にピ アソンへの追加支アソ ンページの URL。リンク先ページの URL。該当するコンテンツの説明、および当該コン テンツが禁止コンテンツまたは不適切なコンテンツであると信じる根拠。調査の際にピ アソンへの追加支'
      },
      '14': {
        question: '14. 本サービスの利用可能性',
        paragraph1:
          'お客様は、本サービスについて、（1）機能させるにはインターネットアクセスが必要であること、（2）メンテナンスまたは緊急時にオフラインになる場合があること、および（3）時の経過とともに変化する可能性のある特徴および機能が搭載されていることを了解します。',
        paragraph2:
          '本サービスの範囲および利用可能性は、以下に応じて変わる場合があります。<strong>（1）</strong>購入または登録時に提示される追加条件、<strong>（2）</strong>お客様が入会または登録している特定の本コースまたは本サービス、および／または<strong>（3）</strong>ピアソンとお客様の教育機関との間で締結されるライセンス規定。ピアソンは、第三者サービスに起因するアクセス制限、またはお客様の教育機関が定める特定のアカウント設定の結果について責任を負いません。',
        paragraph3:
          'お客様は、本サービスを利用するためのインターネットアクセスを取得する責任を負い ます。本 UTOS に基づくピアソンのアクセス終了権を前提としたうえで、お客様は、本 サービスの利用の有無にかかわらず、購入している本サブスクリプション期間に限り （一般的には本コースに応じて、<strong>1</strong> 学期間または <strong>2</strong> 学期間）、本サービスを通じて提供 される本コースにアクセスできます。教育機関には異なる期間のアクセスが提供されま す。',
        paragraph4:
          'ピアソンは、アクティブな本サブスクリプションを保有している承認ユーザーに本サービスの利用を確保できるよう相当な努力を尽くしていますが、本サービスは、定期メンテナンスや緊急メンテナンス、またはインターネットサービスの混乱、本サービスの完全性やセキュリティに対する予期しない脅威といったピアソンの支配を超える要因により、限定期間、利用できなくなる場合があります。',
        paragraph5:
          'ピアソンは、いつでもお客様に予告して、またはお客様への予告なく、本サービスの利用および利用可能性を制限し、および／または本サービスのいずれかの部分、機能またはコンテンツを中止する場合があります。ピアソンは、合理的に実施可能な場合は、アクティブな本サブスクリプションを保有している承認ユーザーに、本サービスの重要な変更に関する通知を行うよう相当な努力を尽くします。本サービスの変更および本サービスの利用可能性に関する情報および更新は、定期的に<a href="https://support.pearson.com/getsupport/" target="_blank">ピアソンサポート</a>に掲載します。'
      },
      '15': {
        question: '15. 保証なく提供される本サービス',
        paragraph1:
          '時折、本サービスの利用可能性およびパフォーマンスが完全とはいえない状態になる場合がありますが、それにもかかわらず、お客様は、ご自身の責任において、「現状のまま」本サービスを利用することに同意します。',
        paragraph2:
          'お客様は、以下のすべてを明示的に了解し、同意します。（1）本サービスの利用はお客様ご自身の責任で行うこと。（2）本サービスは「現状のまま」、「提供可能な範囲で」提供されること。（3）ピアソンの代理店または再販業者が本サービスの保証またはピアソンの責任の基礎を形成するとみなされる表明、情報またはアドバイスを行った場合でも、お客様はかかる表明等に依拠しないこと。（4）適用法で認められる最大限の範囲で、ピアソンならびに当社のライセンサおよび請負業者は、履行過程、取引過程、取引慣行で行われるあらゆる種類のすべての明示または黙示による保証および条件を否認すること（商品性、特定目的への適合性および非侵害に関する黙示の保証等を含みます）。',
        paragraph3:
          'ピアソンまたは当社のライセンサは、以下のいずれについても表明または保証を行いません。（1）本サービスまたは本サービスの利用に中断またはエラーが生じないこと。（2）本サービスを利用して取得される結果が正確であり、または信頼性があること。（3）本サービスがお客様の要求を満たすこと。',
        paragraph4:
          'マテリアルの本サービスへのアップロード、本サービスからのダウンロード、または本サービスからのその他のものの取得は、お客様ご自身の判断と責任で行うものとします。ピアソンまたは当社のライセンサは、本サービスの利用を通じてお客様がアップロードまたは入力したデータの喪失または破損、および本サービスを利用した結果として生じる可能性のあるお客様のハードウェアやソフトウェアの保守、損傷の修理、または是正について責任を負わず、お客様ご自身がそのすべてについて責任を負うものとします。',
        paragraph5:
          '法域によっては、黙示の保証または消費者保証の除外が認められない場合があり、かかる場合は、上記の除外がお客様に適用されないことがあります。'
      },
      '16': {
        question: '16. ピアソンがお客様に対して負う責任の制限',
        paragraph1:
          '本サービスに何らかの不具合が生じた場合、ピアソンがお客様に対して負う責任は、お客様による請求が可能な範囲に制限されます。',
        paragraph2:
          '本 UTOS のいずれの規定によっても、適用法に基づいて適法に除外または制限できない 条件、保証、権利、または責任は、除外または制限されません。したがって、お客様に 適用されるのは、お客様の法域における適法な制限のみであり、かかる場合、当社の責 任は認められる最大限の範囲で制限されるものとします。',
        paragraph3:
          'いかなる場合でも、ピアソン、当社の従業員、役員、代理人、請負業者、またはライセ ンサは、あらゆる種類の補償的、付随的、間接、特別、懲罰的、または派生的な損害に ついて（本サービス、第三者のウェブサイト、もしくは本サービスを通じてアクセスす るアプリケーションの利用もしくは利用不能に基づく請求もしくは損害、財産的損害、 第三者の請求、利益、のれん、データの喪失、その他の無形資産損失、本サービスを通 じて提供されるコンテンツまたは情報にお客様が依拠したことにより生じる損失、およ び／または本サービスの利用に起因するあらゆる種類のその他の損失等を含みます）、 責任を負いません。本サービスに関連してピアソンが負う責任の最大総額は、いかなる 場合でも、損失が発生した特定の本サービスに関してお客様が支払った料金の合計額を 超えないものとします。本条に記載する制限は、契約、不法行為、その他等を根拠に主 張される責任であるか、またはピアソンが当該損失または損害の可能性を知らされてい たかを問わず、および／または本 UTOS に定める限定的な救済では本 UTOS の本質的な 目的が達成されない場合でも適用されます。',
        paragraph4:
          '形式を問わずお客様から行われる本 UTOS に起因する訴訟は、お客様が訴因の根拠とな る事実を知るかまたは合理的に知るべきであった時から 1 年を超えたときは、一切提起 できないものとします。'
      },
      '17': {
        question: '17. お客様に起因するピアソンの損害に対するお客様の責任',
        paragraph1:
          'お客様は、本規則に違反して、または違法な目的で本サービスを利用しないことに同意します。上記の行為を行った場合、お客様は、お客様に起因する損害をピアソンに補償することに同意します。',
        paragraph2:
          '本サービスを利用する条件として、お客様は、ピアソンに対して、以下のすべてを保証 し、表明します。（1）承認ユーザーであること。（2）適用される地方、州、国および 国際レベルの法律または規則、および／または本サービスの利用に適用されるお客様の 教育機関の学則または方針のすべてを常に遵守すること。（3）違法または本 UTOS も しくは<a href="https://loginstatic.pearson.com/html/AcceptableUsePolicy.html" target="_blank">AUP</a> で禁止される目的で、本サービスを利用しないこと。適用法で認められる最 大限の範囲で、お客様は、本 UTOS の違反または本サービスの許可されない利用に起因 するかまたは何らかの形で関連するすべての請求、損害、支出または責任について、ピ アソンならびに当社の従業員、役員、代理人、請負業者およびライセンサを防御し、免 責し、補償することに同意します。'
      },
      '18': {
        question: '18. お客様と当社間の紛争に適用される法律、および請求を提起できる裁判所',
        paragraph1:
          '本サービスに関する訴訟の解決は、（お住まいの地域に応じて）ニューヨーク州、オンタリオ州、オーストラリア、またはイングランドの裁判所で行います。',
        paragraph2:
          'お客様は、本 UTOS には国際物品売買契約に関する国際連合条約は適用されないこと、 および本 UTOS またはお客様による本サービスの利用に関連するあらゆる訴訟、紛争ま たは論争（以下それぞれを<strong>「本請求」</strong>）には、本条項の条件が適用されることに同意します。',
        paragraph3:
          '米国にお住まいのお客様：お客様は、（1）本請求に関して、ニューヨーク州ニューヨーク郡に所在する裁判所の対人専属管轄権および裁判籍に服し、（2）本請求は、抵触法の原則の適用を排除したうえで、ニューヨーク州法を準拠法とし、同法に従って解釈されることに同意します。',
        paragraph4:
          'カナダにお住まいのお客様：お客様は、（1）オンタリオ州に所在する裁判所の対人専属管轄権および裁判籍に服し、（2）本請求は、抵触法の原則の適用を排除したうえで、オンタリオ州法および同州に適用されるカナダ法を準拠法とし、同法に従って解釈されることに同意します。',
        paragraph5:
          '欧州連合（以下「<strong>EU</strong>」）にお住まいのお客様は、お住まいの国、またはイングランドおよびウェールズにおいて当社に対する本請求を提出できます。ただし、本請求は、抵触法の原則を適用したうえで、イングランドおよびウェールズの法律を準拠法とし、同法に従って解釈されることに同意します。',
        paragraph6:
          'オーストラリアにお住まいのお客様：お客様は、（1）ビクトリア州に所在する裁判所の対人専属管轄権および裁判籍に服し、（2）本請求は、抵触法の原則の適用を排除したうえで、ビクトリア州法を準拠法とし、同法に従って解釈されることに同意します。',
        paragraph7:
          '米国、<strong>EU</strong>、オーストラリア、およびカナダ以外にお住まいのお客様：お客様は、（1）イングランドおよびウェールズに所在する裁判所の対人専属管轄権および裁判籍に服し、（2）本請求は、抵触法の原則の適用を排除したうえで、イングランドおよびウェールズの法律を準拠法とし、同法に従って解釈されることに同意します。'
      },
      '19': {
        question: '19. 輸出法の遵守',
        paragraph1:
          '以下のいずれかに該当するお客様は、本サービスを利用してはなりません。（1）米国政府が「テロ支援」国家と指定する国に所在しているお客様、または（2）米国政府の禁止対象者リストまたは制限対象者リストに記載されているお客様。またお客様は、米国輸出許可が必要な国に対して本サービスを輸出しないことを約束します',
        paragraph2:
          'お客様による本サービス、本アプリケーション、および関連テクノロジの利用には、米国または国際レベルの規制や輸出に関連する法律および規則（以下<strong>「輸出法令」</strong>）が適用されます。上記に限定されることなく、お客様は、かかるすべての輸出法令を厳格に遵守すること、ならびに必要に応じて、本アプリケーションおよび関連テクノロジを輸出、再輸出または輸入するための許可を取得する責任を負うことに同意します。お客様は、以下のすべてを表明し、保証します。（1）米国政府の通商禁止対象国、または米国政府が「テロ支援」国家と指定している国に所在していないこと。（2）米国政府の禁止対象者リストまたは制限対象者リストに記載されていないこと。お客様は、直接または間接を問わず、電子的手段等により、米国政府または米国政府機関が輸出ライセンスの取得を義務付ける国または輸出制限を課している国に対し、あるいは当該国の代理人、代理店または外国籍の者に対し、本サービスを移転しないことに同意します。お客様は、本条に基づくお客様の義務の違反に起因または関連するすべての請求、損失、責任、損害、科料、罰金、費用および支出（弁護士料等を含みます）について、ピアソンを免責し、補償します。'
      },
      '20': {
        question: '20. 本サブスクリプションおよび本サービスへのアクセスの終了',
        paragraph1:
          'お客様またはピアソンは、下記に定める理由に基づき、いつでもお客様の本サブスクリプションを解約することができます。',
        paragraph2:
          '<strong> （1）トライアルアクセス。</strong>ケースバイケースで、トライアルレビュー期間中（通常 は最大で 15 日間。以下<strong>「レビュー期間」</strong>」）、本サービスがお客様に提供される場合が あります。レビュー期間中、本サービスへのアクセスは無償で提供されます。ただし、 レビュー期間が期限付きであり、レビュー期間の終了前までに支払いが行われない場 合、トライアルレビューのための本サービスへのアクセスは終了します。本サービスが 終了してもお客様のユーザーアカウントは自動的に終了しません。さらに、ピアソンが レビュー期間のいずれかの時点で、有料の本サービスに関するお客様によるレビュー期 間の利用が誰かを代理してまたは誰かから委託されて行われていると単独の裁量で判断 した場合、ピアソンは、レビュー期間が認められた該当する本サービスへのお客様のア クセスを直ちに終了または停止できるものとし、お客様はその旨を明示的に確認し、了 承します。本サービスへのお客様のアクセスが停止または終了した場合、お客様は、 （1）お客様または他者は、本サービス、その機能、アクティビティ、マテリアル、ま たは当該本サービス等を利用して作成した成果を利用できないこと、および（2）お客 様または他者は、本コース、その機能、アクティビティ、またはマテリアル（本コース または本サービス内での提供かどうかを問いません）を利用して作成した成果にアクセ スしたり、利用したりできないことを確認し、了承します。お客様が本コースの本サブ スクリプションを購入しなかったため本コースへのアクセスが終了したが、以後の支払 金受領の時点でピアソンが本コースへのアクセスを復活させた場合、復活したアクセス には引き続き本 UTOS の規定が適用されます。',
        paragraph3:
          '<strong>（2）お客様による終了。</strong>お客様の教育機関または本サービスへのアクセスを提供する第三者サービスによって課されるアカウント制限を条件に、お客様は、ピアソンに通知して、いつでもご自身のユーザーアカウントを終了することができます。当社にとって重要なことは、お客様が本サービスに満足することです。本サービスについての懸念や苦情、または本サービスへのアクセスを終了したいと考える場合は、当社（<a href="https://pearson.tfaforms.net/3048" target="_blank">ピアソンサポート</a>）までご連絡ください。',
        paragraph4:
          '<strong>（3）ピアソンによる終了。</strong>本 UTOS 違反または AUP 違反であると当社が合理的に信 じる行為または利用が行われた場合（お客様によるものか、またはお客様のユーザーア カウントに基づいて本サービスにアクセスした他者によるものかを問いません）、ピア ソンは、かかる行為または利用が行われたことを理由に、予告して、または予告なく、 および／またはお客様の教育機関からの要請に応じて、自己の単独の裁量に基づき、本 サービスの全部もしくは一部へのお客様によるアクセス、またはお客様の利用権を停止 または終了することができます。',
        paragraph5:
          '<strong>（4）終了の効果。</strong>本 UTOS および AUP の条件、ならびに本 UTOS の第 10 条、第 20 条、および第 21 条は、お客様、お客様の教育機関またはピアソンからの申し立てによ る終了かどうかを問わず、終了後も存続するものとします。ユーザーアカウント情報、 データ、設定もしくは仕様、またはお客様固有のユーザーアカウントに関する本サービ スもしくは本サブスクリプションのカスタマイゼーションは、お客様、ピアソン、また はお客様の教育機関による終了かどうかを問わず、本サービスまたは本サブスクリプシ ョンが終了した時点で永久的に失われます。お客様の教育機関は、終了後も、ユーザー コンテンツおよびお客様による本サービスの利用に関連するその他のユーザー情報にア クセスすることができます。またはパブリックフォーラムに情報が投稿されている範囲 で、投稿の対象である本サービスの他のユーザーも閲覧することができます。'
      },
      '21': {
        question: '21. お客様に提供される本 UTOS に基づく唯一の救済',
        paragraph1:
          '不具合が生じた場合に本 UTOS に基づいてお客様に提供される唯一の救済は、（1）本 サービスへのアクセスの回復、または（2）案分による料金の返金です。',
        paragraph2:
          '本サービスの利用に関し、ピアソンがお客様に対して負うすべての責任、およびお客様に提供される唯一かつ排他的な救済は、ピアソンの単独の裁量に基づき、以下のいずれかとなります。（1）お客様が購入した本サービスへのアクセスの回復。（2）お客様が特定の本サービスまたは本サブスクリプションに関してピアソンに直接支払った料金の案分による返金。',
        paragraph3:
          '書面での要求が可能な場合、返金は、受講登録または登録後 15 日以内にお客様が書面 で要求した場合にのみ行われます。返金の提供は、承認ユーザーがピアソンのウェブサ イトから直接購入した場合に限り可能となります。アクセスコードの紛失や盗難を理由 とする場合、または第三者を通じて購入した場合（お客様の学内書店での購入など） は、返金に応じることはできません。本サービスに不満がある場合、または返金を希望 する場合は、当社（<a target="_blank" href="https://pearson.tfaforms.net/3048">ピアソンサポート</a>）までご連絡ください。',
        paragraph4:
          'オーストラリアにお住まいの場合、本サービスには、オーストラリア消費者法（消費者保護）に基づいて除外できない保証および製品保証が付帯します。本サービスが消費者保護に準拠していない場合にお客様が受けることができる救済は、消費者保護の不遵守が重大なものか軽微なものかによって異なります。'
      },
      '22': {
        question: '22. 追加的な雑則規定',
        paragraph1:
          '本 UTOS はお客様ご自身に対して適用されるものであり、お客様は、本 UTOS または<a href="https://loginstatic.pearson.com/html/AcceptableUsePolicy.html" target="_blank">AUP</a>（以下総称して<strong>「本規約」</strong>）に基づくご自身のユーザーアカウントまたは権利もし くは義務を他者に譲渡、移転または委譲することはできません。ピアソンは、本規約お よび当社がお客様の教育機関との間で締結する契約に基づき付与される権利および義務 に従って、本規約に基づく自己の権利または義務の全部または一部を譲渡または委譲す ることができます。いずれかの管轄裁判所が本規約のいずれかの条項を何らかの理由に より無効または執行不能と判示しても、本規約の残りの規定は、本規約の規定に従って 有効かつ執行可能な状態で存続します。本規約は、本サービスに関するピアソンとお客 様との間の完全な合意を構成し、署名を付した書面による合意がない限り、変更するこ とはできません。本規約に記載されている条項の見出しおよび要約は、便宜のためにの み記載されており、法的な意味や効力を有しません。1 回か複数回かを問わず、本規約 のいずれかの条件についてピアソンが権利放棄をするかまたは権利行使を怠った場合で も、当該規定に関する権利放棄または不行使が、別の時期における本規約のいずれかの 条件に対するピアソンの権利行使を妨げることはないものとします。両当事者の明示的 な要望に基づいて、本規約およびすべての関連文書は英語で作成されます。 C’est la volonté expresse des parties que la présente convention ainsi que les documents qui s’y rattachent soint rédigés en anglais.'
      }
    },
    preSection2: {
      header: '{{productName}} 補足条項'
    },
    content2: {
      '1': {
        question: '1. はじめに',
        bullet1:
          '補足条項（以下「VPEC 補足条項」）は、Pearson Education Ltd (以下「ピアソン」または「当社」）と当社または世界各国の当社の関連会社でピアソン 英語スキル証明書（以下「VPEC」（以下「受験者」または「あな た」）との間における契約に組み込まれ、その一部を形成します。',
        bullet2:
          '受験者は、試験の購入を完了する前に、本 VPEC 補足条項に同意する必要があります。 あなたは、ピアソンによって、またはピアソンに代わって行われた声明、約束、表明、 保証のうち、本 VPEC 補足条項に定められていないいかなる保証にも依拠していないこ とを認めるものとします。',
        bullet3:
          '本 VPEC 補足条項、ユニバーサルサービス規約およびエンドユーザーライセンス契約 書、 受験者向けVPEC 公式ガイド（以下「本ガイド」）は、VPEC に関する当社と受験者 との間における完全な契約を形成します。'
      },
      '2': {
        question: '2. VPEC 公式ガイド',
        bullet1:
          'このガイド は、こちらで入手できます。また、<a target="_blank" href="{{ url }}">{{ url }}</a>から入手できるすべての関連資料（<strong>FAQ</strong> やビデオなど）には、 VPEC に適用される規則や規制の詳細（テストの準備の詳細など）が含まれています。VPEC テストの登録または取得により、あなたは、本ガイドを読み、理解し、本ガイドに 拘束されることに同意したことを表明することになります。',
        bullet2:
          'あなたは、本ガイドと関連資料に定められている規則に従わない場合、当社が結果の認証を行わないようにするなどの措置を講じることができることに同意するものとします。'
      },
      '3': {
        question: '3. プライバシー',
        bullet1:
          'ピアソンは、登録、スケジュール調整、テスト受験のプロセスにおけるすべての段階で、あなたに関する個人情報をあなたから収集します。すべての個人情報は安全かつ安心な方法で収集、送信、保存され、<a target="_blank" href="{{ url }}/privacy-policy"> こちら</a>で閲覧可能なプライバシーステートメントに記載されている目的でのみ使用されます。.'
      },
      '4': {
        question: '4. 秘密保持',
        bullet1:
          '受験者は、テストの問題や解答のコピーを取ったり、テストの項目や解答を他者と共有したりすることはできません。これには、学習ガイドや演習セッションにおけるテスト項目や解答の非商用利用の禁止も含まれます。'
      },
      '5': {
        question: '5. キャンセルおよび返金に関するポリシー',
        bullet1:
          '購入後 90 日以内でテストが開始されていない場合は、テストの全額返金を請求できま す。当社は、テストの購入に使用された支払方法を用いてテスト料金（GST/VAT/消費税 /政府賦課金を含みます）を返金し、あなたのアプリケーションからテストを削除しま す。',
        bullet2:
          'ただし、ピアソンの意図的な違法行為または重大な過失がある場合を除き、 <u>テスト開始後（機器の故障を理由とする場合を含みます）の場合は、テストの購入時期にかかわらず、テストをキャンセルして返金を請求することはできません。</u>テストは、セットアップチェックが完了した時点で開始されたとみなされます。',
        bullet3:
          'システム障害によりテストを完了できない場合、ピアソンは、独自の判断で、代替テストまたは返金を行うことができます。',
        bullet4:
          '問題が発生した場合は、<a target="_blank" href="https://pearson.tfaforms.net/3048">このフォーム</a>を使用して、調査のために当社のカスタマーサービスチームへの報告が必要です。',
        bullet5:
          'このキャンセルおよび払い戻しに関するポリシーのいかなる規定も、消費者法や規制に基づき、または技術的な欠陥がピアソンのみに起因する場合にあなたが有するいかなる権利にも優先するものではありません。'
      },
      '6': {
        question: '6. 責任の制限',
        bullet1:
          'ピアソンは、その過失または従業員もしくは代理人に起因する死亡もしくは人身傷害、または不正な不実表示に関する責任を制限したり、除外したりすることはありません',
        bullet2:
          '上記の第 6 条（a）に従い、適用法で認められる最大限の範囲において、ピアソンは、 契約、不法行為（過失を含みます）、その他を問わず、いかなる状況においても、（i） VPEC またはあなたのテストに関連するピアソンの作為または不作為の結果として、あな たが被った事業機会の損失、利益の損失、機会の損失、または間接的もしくは結果的な 損失。（ii）テストセンター、その従業員もしくは代理人による、またはその代理とし てのあらゆる作為または不作為のいずれについてもあなたに対する責任を負いません。',
        bullet3:
          'ピアソンがあなたに対して負う、あなたが被ったその他すべての費用または損失に関する責任の総額は、法律で別段の定めがある場合を除き、関連するテストに関してあなたがピアソンに支払った金額を超えないものとします。',
        bullet4:
          'VPEC の提供に関する当社の義務のうち、当社の合理的な支配の及ばない状況により生じ たものを当社が履行しなかった場合、または履行が遅延した場合、当社は、これらの義 務を履行するための合理的な期間延長を受ける権利を有します。'
      },
      '7': {
        question: '7. 一般条項',
        bullet1:
          '当社は、本 VPEC 補足条項を随時改訂することがあります。重要な変更がある場合は、 ご提供いただいた連絡先の電子メールアドレスに電子メールでその旨をお知らせしま す。',
        bullet2:
          '矛盾がある場合は、本 VPEC 補足条項が優先され、続いてユニバーサルサービス規約お よびエンドユーザーライセンス契約書、次に受験者向け VPEC 公式ガイドの順に適用さ れます',
        bullet3:
          '本 VPEC 補足条項のいずれかが管轄当局により無効、違法、または執行不能と判断され た場合、当該条項、条件または規定は、その限りにおいて、法律で認められる最大限の 範囲で有効に存続する残りの条項、条件および規定から切り離されます。',
        bullet4:
          '当社が本 VPEC 補足条項のいずれかに基づくお客様の義務の厳格な履行を要求しなかっ た場合、 または当社が付与されている権利もしくは救済を行使しなかった場合でも、か かる権利または救済の放棄とはみなされず、あなたの当該義務の遵守は免除されないも のとします。当社が不履行を放棄した場合でも、その後の不履行の放棄とはみなされな いものとします。'
      },
      '8': {
        question: '8. 連絡先の詳細',
        bullet1:
          '何か問題があれば、<a target="_blank" href="https://pearson.tfaforms.net/3048">このフォーム</a>を使用して当社のカスタマーサービスチームにお問い合わせください。'
      }
    }
  },
  cookiePolicy: {
    downloadButton: 'Cookieポリシーダウンロード',
    header: 'Cookie ポリシー',
    subheader:
      'Cookie ポリシーが更新されました。変更点には、「個人情報の販売禁止およびカリフォルニア 州消費者プライバシー法」に関する新しいセクション、および Cookie のリストの更新が含まれ ます。',
    preSection: {
      header: 'ユニバーサルサービス利用規約およびエンドユーザーライセンス契約',
      paragraph1: `本 Cookie ポリシーは、Pearson Education, Inc.（所在地：221 River Street, Hoboken, New Jersey 07030）がその子会社および関連会社（ピアソン）と共同で提供する本サ イト（pearson.com/en-us.html）で使用される Cookie に関する情報を提供します。本 Cookie ポリシーは、本サイトの<a href="{{privacyPolicyLink}}"><strong>プライバシーポリシー</strong></a>と併せてお読みください。`,
      paragraph2:
        '他の多くのウェブサイトと同様に、本サイトは Cookie を使用してユーザーの好みを保 存し、ウェブサイトをより使いやすくし、サイトの利用状況やパフォーマンスに関する 情報を収集し、ターゲットを絞ったメッセージやマーケティングを促進します。'
    },
    content: {
      paragraph1: {
        header: '個人情報の販売禁止およびカリフォルニア州消費者プライバシー法',
        description:
          'カリフォルニア州、コロラド州、コネチカット州、ネバダ州、ユタ州、バージニア州などのいくつかの州では、個人情報の販売、個人情報の共有、またはその両方をオプトアウトするさまざまな権利が居住者に付与されています。'
      },
      paragraph2: {
        description:
          'ピアソンは、過去 12 か月間以内に本サービスを通じて収集された個人情報を販売・共有<strong>しておらず</strong>、販売・ 共有<strong>したこともありません</strong>。'
      },
      paragraph3: {
        header: 'Cookie の無効化またはブロック',
        description:
          'Cookie は、ユーザーが使用するコンピュータおよびブラウザにおけるインターネット ブラウザの設定により、ブロックまたは無効化を行うことができます。さらに、ユーザ ーは、ネットワーク広告イニシアティブ<br /><a href="http://optout.networkadvertising.org" target="_blank">http://optout.networkadvertising.org/</a>）またはデジタル広告アライアンス<br /> （<a href="http://optout.aboutads.info" target="_blank">http://optout.aboutads.info/</a>）に参加している広告ネットワークや企業のオプトアウトツールを使用できます。'
      },
      paragraph4: {
        description:
          'ブラウザ設定や広告業界のオプトアウトツールを使用して Cookie を効果的に管理する には、すべてのブラウザと使用するすべてのデバイスで Cookie のオプトアウトや設定 行います。また、キャッシュや Cookie をクリアしてから、設定を確認し、リセットし ます。'
      },
      paragraph5: {
        description:
          'なお、Cookie の無効化やブロックを行うと、本サイトや他のサイトの機能が低下することがあります。'
      },
      paragraph6: {
        description:
          'Cookie の無効化やブロックを行うためのブラウザ設定の表示と変更については、次の 情報を参照してください。'
      },
      paragraph7: {
        description:
          'Google Chrome<br /> スパナアイコン（ブラウザの上部メニュー）をクリックし、［設定］を選択します<br /> 左側の［ボンネットの下］タブをクリックし、［コンテンツの設定］ボダンを選択します<br />Cookie セクションで、ニーズに最も適したオプションを選択します。\n'
      },
      paragraph8: {
        description:
          'Microsoft Internet Explorer<br /> ［ツール］（ブラウザの上部メニュー）をクリックし、［インターネットオプション］を選択します <br /> ［プライバシー］タブをクリックします<br /> プライバシースライダを必要なプライバシーレベルまで動かします。［中］以上に設定すると、<br /> Cookie が無効化されます。'
      },
      paragraph9: {
        description:
          'Mozilla Firefox<br /> ［ツール］（ブラウザの上部メニュー）をクリックし、［オプション］を選択しますプライバシーアイコンを選択します<br /> ［履歴］セクションで、ドロップダウンメニューから［履歴にカスタム設定を使用する］を選択します<br /> 該当するチェックボックスをクリックすることで、Cookie の有効化または無効化を行 えます。'
      },
      paragraph10: {
        description:
          'Safari<br /> コグアイコン（ブラウザの上部メニュー）をクリックし、［環境設定］を選択します［プライバシー］タブをクリックし、ニーズに最も適したオプションを選択します'
      },
      paragraph11: {
        description:
          'Opera<br /> ブラウザウィンドウの上部にある［ツール］をクリックし、［環境設定］を選択します［詳細設定］タブを選択し、左側のリストから［Cookie］を選択しますニーズに最も適したオプションを選択します'
      },
      paragraph12: {
        description:
          'OSX の Safari<br /> ブラウザウィンドウの上部にある［Safari］をクリックし、［環境設定］を選択します［プライバシー］タブをクリックします<br /> Cookie の受け入れレベルをここで調整します。'
      },
      paragraph13: {
        description:
          'Firefox<br /> ブラウザウィンドウの上部にある［Firefox］をクリックし、［環境設定］を選択しますプライバシーアイコンを選択します<br /> ［履歴］セクションで、ドロップダウンメニューから［履歴にカスタム設定を使用する］を選択します<br /> 該当するチェックボックスをクリックすることで、Cookie の有効化または無効化を行 えます'
      },
      paragraph14: {
        header: 'Cookie のリスト',
        description:
          'Cookie は通常、次の 4 つのカテゴリーに分類されます。（1）厳密に必要な Cookie、 （2）パフォーマンス Cookie、（3）機能性 Cookie、（4）行動ターゲティング広告/マ ーケティング Cookie。'
      },
      paragraph15: {
        description:
          '本サイト（pearson.com/us）に関連して使用される Cookie には、これらの各カテゴリ ーの Cookie が含まれ、以下に示すもの（ただし、これらに限定されません）が含まれ る場合があります。'
      },
      paragraph16: {
        description:
          'なお、当社のオンライン製品やサービスを含む他のピアソンサイトにおける Cookie の 使用は異なる場合があり、たとえば、行動ターゲティングマーケティング Cookie が場 外される場合があります。'
      },
      paragraph17: {
        header: '厳密に必要な Cookie',
        bullet1: {
          description:
            'セッションベース：分析のためにサイトの利用に関する情報を収集し、サイトの運営を改善したり、問題を特定して対応したりするため。',
          subbullet1:
            '<strong>AWSALB, AWSELB</strong> – 「スティッキーセッション」を作成するために AWS が設 定する Cookie',
          subbullet2: '<strong>YSESSIONID</strong> – Hybris セッション ID',
          subbullet3:
            '<strong>acceleratorSecureGUID</strong> – Hybris セキュア GUID Cookie では、ユーザーのセ ッションが有効かどうかを評価します',
          subbullet4:
            '<strong>cookie-notification</strong> – ユーザーが Cookie 通知のポップアップを閉じたときに'
        },
        bullet2: {
          description:
            'ジオターゲティング：ユーザーの国や州を特定し、その地域や管轄に関連する情報を表示できるようにするために使用されます。',
          subbullet1:
            '<strong>geotargetsite</strong> – Akamai を経由して IP に基づくユーザーの位置を追跡します',
          subbullet2:
            '<strong>geotargetchosenlocale</strong> – ユーザーが特定の国の店舗に移動することを選択した場合に追跡します',
          subbullet3:
            '<strong>system-msg</strong> – ヘッダー内のグローバルメッセージコンポーネントに使用されます'
        },
        bullet3: {
          description:
            'ユーザーがサイトをどのように利用し、どのようなやり取りを行っているのかに関するデータを収集します。当社サイトのパフォーマンスを分析し、カスタマーエクスペリエンスを最適化するために使用されます。',
          subbullet1:
            '<strong>_utma</strong> – ユニークビジターを追跡する Google Analytics の Cookie',
          subbullet2:
            '<strong>_utmb</strong> – 訪問者の行動を追跡し、サイトのパフォーマンスを評価する Google Analytics の Cookie',
          subbullet3:
            '<strong>_utmc</strong> – 訪問者の行動を追跡し、サイトのパフォーマンスを評価する Google Analytics の Cookie',
          subbullet4:
            '<strong>_utmt</strong> – – サービスのリクエスト率を調整する Google Analytics の Cookie',
          subbullet5:
            '<strong>_utmv</strong> – ユーザーの分類に使用される Google Analytics の Cookie',
          subbullet6: '<strong>_utmz</strong> – Google Analytics の Cookie',
          subbullet7: '<strong>_ga</strong> – ユーザーを識別する Google Analytics の Cookie',
          subbullet8: '<strong>_gat_UA-93818630</strong> – Google Analytics アカウント番号の識別子',
          subbullet9: '<strong>_gid</strong> – ユーザーを識別する Google Analytics の Cookie',
          subbullet10:
            '<strong>_rollupGa</strong> – 一意のクライアント識別子を保存するための Google Analytics の Cookie'
        }
      },
      paragraph18: {
        header: 'パフォーマンス Cookie',
        bullet1: {
          description:
            '最適化：多変量テストツール。カスタマーエクスペリエンスの最適化に使用されます。'
        },
        bullet2: {
          description:
            'hotjar：ユーザーによるサイトとのやり取りのヒートマップを記録します。サイトのパフォーマンスを分析し、カスタマーエクスペリエンスを最適化するために使用されます。'
        },
        bullet3: {
          description:
            'LiveIntent：デバイス間の識別ツール。ウェブサイトの分析やユーザーエクスペリエンスの最適化に使用されます。'
        }
      },
      paragraph19: {
        header: '機能性 Cookie',
        bullet1: {
          description: 'Maritz：顧客満足度調査の実施に使用されます。'
        }
      },
      paragraph20: {
        header: '行動ターゲティング広告 Cookie',
        bullet1: {
          description:
            'Pardot：顧客とキャンペーンの追跡に使用されるマーケティングプラットフォーム。顧客の興味やターゲットを絞ったキャンペーンに対する反応を特定するために使用されます。ピアソンの使用に関する情報を収集する場合にのみ有効化されます。'
        },
        bullet2: {
          description:
            'Facebook：ソーシャルメディアマーケティング。Facebook プラットフォームに展開さ れるマーケティングキャンペーンの追跡や評価に使用されます。Facebook は、これら のツールを通じて顧客の行動を追跡します。'
        },
        bullet3: {
          description:
            'Twitter：ソーシャルメディアマーケティング。Twitter プラットフォームに展開される マーケティングキャンペーンの追跡や評価に使用されます。'
        },
        bullet4: {
          description:
            '• Linked In：ソーシャルメディアマーケティング。Linked In プラットフォームに展開さ れるマーケティングキャンペーンの追跡や評価に使用されます。'
        },
        bullet5: {
          description:
            'Google Ads：メディアマーケティングを検索します。Google 検索および関連する Google サービス内におけるマーケティングキャンペーンの追跡や評価に使用されま す。'
        },
        bullet6: {
          description:
            'Salesforce：セールスサポートツール。顧客によるサポートツールの利用状況の追跡や評価に使用されます。ピアソンの使用に関する情報を収集する場合にのみ有効化されます。'
        },
        bullet7: {
          description:
            'Pearson Education：セールスサポートツール。顧客による e コマースの利用状況の追 跡や評価に使用されます。'
        }
      },
      paragraph21: {
        header: '変更',
        description:
          '当社は、掲載の更新を通じて、本 Cookie ポリシーを改訂することがあります。当社 は、掲載内で改訂の発効日を特定します。より明確にするため、または規制要件の変更 に準拠するために、頻繁に更新が行われる場合があります。更新に重要な変更が含まれ る場合、本サイト上の目立つ場所に通知するか、その他の適切な方法で変更を通知しま す。掲載された改訂の発効日以降も本サイトの利用を継続した場合、受諾したものとみ なされます。変更に関してご質問、ご不明な点、ご意見などがある場合は、当社までお 問い合わせください。'
      },
      paragraph22: {
        header: 'お問い合わせ先',
        description:
          '本 Cookie ポリシーについて、またはピアソンが収集・処理する個人情報のプライバシ ーに関するご要望やご質問は、 <a target="_blank" href="https://pearson.tfaforms.net/3048">こちら</a> までお問い合わせください。'
      },
      paragraph23: {
        header: '最終更新日: 2022 年 12 月 13 日'
      }
    }
  },
  results: {
    yourScoreHasBeenSentToEndCustomer: 'スコアは次に送信されました ',
    header: '自分の結果',
    noTestsTakenDescription: 'テストを完了し、こちらをクリックしてあなたの結果を確認しましょう！',
    myTopScoreHeader: 'MyTopScore™（自己最高スコア）',
    gseScore: '全体スコア',
    viewDetails: '詳細を見る',
    skillScoresTableHeaders: ['テスト', 'テスト ID', '日付', 'GSEスコア', 'CEFR', ''],
    myTopScoreTableHeaders: [
      'テスト',
      'テストID',
      '受験日',
      'スピーキング',
      'リスニング',
      'リーディング',
      'ライティング',
      '全体スコア',
      ''
    ],
    resultsTablesHeaders: [
      'テスト',
      '日付',
      'ステータス',
      'スピーキング',
      'リスニング',
      'リーディング',
      'ライティング',
      '全体スコア',
      'CEFR',
      ''
    ],
    resultsPracticeTableHeaders: [
      'テスト',
      '日付',
      'スピーキング',
      'リスニング',
      'リーディング',
      'ライティング',
      '全体スコア',
      ''
    ],
    latestTest: '最新のテスト',
    yourSpeakingWasUnscorable: 'スピーキングテストが採点不能でした。次の詳細をご確認ください',
    somethingWentWrong:
      '不具合が生じました。詳しい情報と無償の再受験のため、テストの詳細をご確認ください。',
    unableToCertifyScore:
      '残念ながらスコアを認定できませんでした。<br/>テストを見直し、詳細を確認してください。',
    appealBeingReviewed:
      '再採点の要請について、担当チームが現在検討しています。後ほど改めて最終スコアをご確認ください。',
    testBeingReviewed:
      'あなたのテストを担当チームが現在審査しています。後ほど改めて最終スコアをご確認ください。',
    uploading:
      'Your responses are being uploaded in the background. Once all the responses are uploaded the certification process will start.',
    thisTestHasStarted:
      'このテストは進行中です。テスト完了後に、あなたのスコアをこちらでご覧ください。',
    testWasNotCompleted: 'このテストは、中断されています。残念ながら、スコアを提供できません。',
    allYourTests: '全テスト',
    allYourPracticeTests: '全ての模擬テスト',
    allResults: '全結果',
    yourTests: 'テスト',
    yourPracticeTests: '模擬テスト',
    resultDetails: '結果の詳細',
    expiresIn: '有効期限: 残り{{daysToExpire}} 日',
    expired: '期限切れ',
    downloadingAssets: 'アセットをダウンロード中',
    resultBadge: {
      certified: 'Certified \n（認定済み）',
      unscorable: '採点不可',
      pendingCertification: 'Pending review \n（審査中）',
      unabletoCertify: '認定不可',
      speakingUnscorable: 'スピーキングの採点不可',
      appealed: '再採点を要請しました',
      started: '開始しました',
      incomplete: '未完了',
      uploading: 'アップロードしています',
      ruleViolation: 'ルール違反',
      inProgress: '進行中',
      completed: '完了しました',
      error: 'エラー',
      lateHangup: '接続中断による終了'
    },
    reasonsforDeniedCertification: '認定不可の理由',
    reason: '理由{{number}}',
    skillScores: 'スキル別のスコア',
    understandingYourSkills: 'あなたのスキルを理解する',
    overallScore: '全体スコア',
    overallScoreDescription:
      '全体スコアでは、日常的な話題についての会話を理解し、英語を母語とする話者のペースでわかりやすく話せるスピーキングの能力が示されています。スコアは、４つの診断項目のサブスコアを加重平均して算出されます',
    gse: 'GSE',
    gseDescription:
      'GSE（Global Scale of English）は、10～90の細かい尺度で構成されるスケールで 英語力の判定に使われます。詳しくは <a>English.com/gse</a> をご覧ください。',
    mtsDescription:
      '<bold>MyTopScore</bold>を計算するために、受験者が過去6ヶ月間に受けたテストの各スキルのベストスコアを使用しました。',
    overallDescription:
      'テストの総合得点は、話し言葉や書き言葉の英語を理解し、学術的な話題や職場での話題について、適切なペースで、聞き取りやすい英語で話したり書いたりする能力を表します。スコアは10点から90点までのGSEスケールで表示されます。',
    sampleResponses: '回答例',
    downloadCertificate: '証明書をダウンロードする',
    writingSampleTitle: 'ライティングのサンプル',
    writingSampleText: '受験者のライティングテストのサンプルを読む',
    speakingSampleTitle: 'スピーキングのサンプル',
    speakingSampleText: '受験者のスピーキングテストのサンプルを聴く',
    speakingSample: 'スピーキングのサンプル',
    writingSample: 'ライティングのサンプル',
    speakingSkill: 'スピーキング能力',
    writingSkill: 'ライティング能力',
    scoreSummary: 'スコアの概要',
    viewMyScore: '自分のスコアを見る',
    viewMyScores: '自分のスコアを見る',
    yourScore: 'あなたのスコア',
    skillOverwiev: '英語能力の概要',
    tipsAndRecommendations: 'ヒントとアドバイス',
    readSample: 'サンプルを読む',
    listentoSample: 'サンプルを聴く',
    certificateOverallHeader: '英語能力',
    sampleResponseTitle: '{{firstName}}の回答例',
    samplePreviewDescription: '以下は {{fullName}} のサンプルです。修正済み {{skill}}I',
    emailPreview: 'Eメールのプレビュー',
    shareResult: '結果を共有する',
    shareYourResults: 'あなたの結果を共有する',
    shareYourResultsHeader: '誰とスコアを共有したいですか？',
    shareYourResultsDescription:
      'プラットフォームでスコア共有を選択すると、共有された方は以下にアクセスすることができます：',
    shareYourResultsCopyOfCertificate: 'あなたの証明書コピー',
    shareYourResultsSamples: 'あなたのスピーチとライティングのサンプル',
    organizationName: '組織名',
    specifyOrganization: '組織名',
    emailAddress: 'Eメールアドレス',
    yourScoreHasBeenSent:
      'スコアがご希望のメールアドレスに送信されました。スコアが閲覧されると通知メールを通知メールを受け取れます',
    previewTheEmailLinkDescription:
      'こちらをクリックすると送信したメールをプレビュー表示できます。',
    invalidEmailAddress: '無効なEメールアドレス',
    previewEmail: 'Eメールをプレビュー表示する',
    shareResults: '結果を共有する',
    atLevel: '標準',
    aboveLevel: 'Above level（標準より上）',
    noTestsDescription: '受験後にこちらにスコアが表示されます',
    belowLevel: 'Below level（標準より下）',
    levelScale: [
      'Below Beginner（初心者以下）',
      'Beginner（初心者）',
      'Elementary（初級）',
      'Intermediate（中級）',
      'Upper-Intermediate（中級の上）',
      'Advanced（上級）',
      'Mastery（名人級）'
    ],
    highlightedScores:
      '*<span>MyTopScore（自己最高スコア）</span>の算出には、ハイライトされたスコアが用いられています',
    credlyBadgeDialogTitle: 'Credlyバッジの取得',
    credlyBadgeDialogRedeemedTitle: 'Credlyバッジを共有します',
    credlyBadgeDialogRedeemedDescription: 'おめでとうございます。Credlyバッジを取得しました。',
    credlyBadgeDialogDescription: `おめでとうございます！{{productName}}のテスト結果でCredly バッジを取得しました。`,
    credlyBadgeDialogRedeemedListDescription:
      'Credlyのあなたのプロフィールにログインし、自分のスキルの共有を始めましょう！',
    credlyBadgeDialogListDescription: 'バッジを共有する3つの簡単な方法：',
    credlyBadgeDialogSteps: [
      'CredlyからのEメールをご確認ください',
      'Eメールのリンクを開き、Credly プロフィールを作成してバッジを受領します',
      '英語力のスキルを示したい相手にバッジを共有しましょう'
    ],
    credlyBadgeDialogButton: 'Credlyについて知る',
    credlyBadgeDialogRedeemedButton: 'Credlyページへ',
    noResultsText: 'テストを受けた後に、あなたのスコアをこちらでご覧ください',
    shareResultsEmailSentSuccess: '共有できました！',
    yourScores: 'あなたのスコア',
    couldNotBeCertified: '検査結果が認証されなかった',
    retakeCompleted: '再受験可能期間が終了しました',
    seeAllResults: 'すべての結果を見る'
  },
  testID: 'テストID',
  testName: 'テスト名',
  shareDetails: {
    sharedWith: '共有者',
    sharing: '共有',
    name: '名称',
    shareDetailsHeaders: ['テストID', '共有日', 'スコア', '共有者', '共有']
  },
  menuLabels: {
    dashboard: 'ダッシュボード',
    results: '結果',
    account: 'アカウント',
    gettingReady: '受験の方法',
    helpCenter: '受験のサポート',
    exploreTests: 'テストの詳細',
    contactUs: 'お問い合わせ',
    logOut: 'ログアウト'
  },
  speaking: 'スピーキング',
  listening: 'リスニング',
  reading: 'リーディング',
  writing: 'ライティング',
  dontHaveAnyTests: 'テストがありません',
  share: '共有する',
  rowsPerPage: '1ページあたりの行数',
  english: '英語',
  japanese: '日本語',
  date: '日付',
  expirationDate: '有効期限',
  account: {
    account: 'アカウント',
    accounts: 'アカウント',
    off: 'オフ',
    on: 'オン',
    areYouSure: '共有を停止してよろしいですか？',
    yesRevoke: 'はい、取り消してください',
    cancel: 'キャンセル',
    dontHaveAnyTestsWithShares: 'スコアを共有すると、このセクションに表示されます'
  },
  pagination: { of: 'ページ中' },
  view: '見る',
  noSampleTextToPreview: 'プレビューできるサンプルテキストはありません。',
  done: '完了',
  thisShouldBeAValidEmailAddress: '有効なEメールアドレスを入力してください',
  send: '送信する',
  here: 'こちら',
  success: '成功',
  score: {
    header: 'スコア',
    scoreReportHeader: 'スコアレポート',
    scores: 'スコア',
    lookup: '証明書の検索'
  },
  play: '再生',
  exam: {
    speakLabel: 'Speak...',
    listenLabel: '聞いてくれ...',
    fetch: 'フェッチ試験'
  },
  layout: {
    next: '次のページ',
    back: 'アック',
    agree: '同意して進める'
  },
  directoryLayout: {
    startTest: 'テスト開始',
    exitTest: '終了テスト'
  },
  ageRestriction: {
    title: '年齢制限',
    thankYouForInterest: `ご関心ありがとうございます。残念ながら、{{productName}}のご利用には年齢制限がございます。`,
    pleaseNote: '14歳以上の方からアカウントの作成が可能となります。',
    backToHomepage: 'ホームページに戻る'
  },
  signUp: {
    header: '登録して、英語力の認定を受けましょう',
    mobileHeader: '登録して、英語力の認定を受けましょう',
    advantages: [
      '無償で模擬テストが受けられます！',
      '準備ができたら本番テストを購入しましょう',
      '受験して48時間で認定結果を共有できるようになります'
    ],
    description: 'もう一歩で、様々な機能をご利用いただけるようになります:',
    shouldBeValidEmail: '有効なEメールアドレスを入力してください',
    withGoogle: 'Googleアカウントで登録する',
    orSignUpWith: 'または、メールアドレスで登録する',
    password: 'パスワード',
    privacyPolicy: '個人情報保護方針',
    charactersLength: '8文字',
    consentLabel: '私は利用規約を読み、同意し、個人情報保護方針を承諾しました。',
    offersDescription: 'あなたのプロフィールや興味に合わせて、情報をお届けすることができます。',
    offersConsentLabel: '私は興味のある製品やサービスの情報をメールで受け取ることに同意します。',
    consentSummaryDescription: '変更したい場合は、いつでも配信を停止することができます。',
    agreeingText: '登録をクリックすると次のポリシーに同意したことになります：',
    cookiePolicy: 'クッキーに関するポリシー',
    alreadyHaveAccount: '既にアカウントをお持ちですか？',
    signIn: 'サインイン',
    agreementsDescription:
      ' <termsOfUseComponent>利用規約</termsOfUseComponent> と <privacyPolicyComponent>個人情報保護方針</privacyPolicyComponent> を読んで、当社がお客様のデータをどのように使用するかをご理解ください。',
    termsOfUse: '利用規約',
    consentIsMandatory: '同意は必須です',
    agreeToAll: 'I agree to all',
    agreementTitle: '同意およびプライバシーポリシーの確認',
    ageConsent: '私は14歳以上です。',
    collectUIIConsentTooltip:
      '弊社では、不正行為を防止するための本人確認を厳密な目的として、個人の国民IDまたはパスポート、および個人のIDと一致する顔写真など、各個人における固有のID情報を収集しています。',
    collectSIConsentTooltip:
      '弊社では、本人確認のみを目的として、個人の声や画像のサンプルを含む、各個人の生体認証データを収集しています。 これにより、受験者の画像および音声を認証済みの身元の画像および音声と照合して、不正行為を防止します。 これは、公平かつ安全に試験を実施するために不可欠な対策です。',
    provisionPIConsentTooltip:
      '弊社は、サービス提供と品質向上のため、信頼できる事業提携者と特定の個人情報を共有しています。 個人情報の使用方法に関する詳細につきましては、こちらをクリックしてご確認ください。',
    transferPIConsentTooltip:
      '収集された個人情報は、米国に転送・保管され、サービス提供の必要に応じて、Pearsonの従業員によって世界中からアクセスされます。 個人情報の転送に関する詳細につきましては、こちらをクリックしてご確認ください。',
    marketingPurposesConsentTooltip:
      '本規約に同意することにより、Pearsonがあなたの個人情報をマーケティング目的のみに収集および使用し、弊社から各個人に合わせた最新情報、プロモーション、およびオファーを送信することを許可するものとします。 メールに記載されたリンクをクリックすることで、いつでも配信を停止できます。',
    countrySpecificPolicies: '同意の確認',
    beforeProceed: '続行前にご確認ください。',
    differentCountryDetected:
      'お住まいの国/地域は、本規約の対象国ではありません。 以下の国別ご利用規約およびプライバシーポリシーへの同意をお願いします。',
    termsAndUseConsent: '<consentLink>利用規約</consentLink>に同意します。',
    collectPIConsent: '<consentLink>個人情報の収集と使用</consentLink>に同意します。',
    collectUIIConsent: '固有識別情報の収集と使用に同意します。',
    collectSIConsent: '機密情報の収集と使用に同意します。',
    provisionPIConsent:
      '<consentLink>個人情報が指定された第三者に提供されること</consentLink>に同意します。',
    transferPIConsent: '<consentLink>個人情報の海外転送</consentLink>に同意します。',
    marketingPurposesConsent: 'マーケティング目的での個人情報の収集と使用に同意します。',
    marketingEmailConsent:
      '個人向けのオファーやマーケティング目的の情報をメールで受け取ることに同意します。'
  },
  downloadPearsonEnglishSkillsCertificate: `テストを受けるために、{{productName}}用のアプリケーションをダウンロードします。`,
  signIn: {
    headerWeb: 'Welcome <br /> back!',
    description: 'アカウントですべてを活用できるまであと一歩です:',
    signUpAndCertify: '登録し、英語力を証明しましょう。',
    signInWithGoogle: 'Googleアカウントでサインインする',
    orSignInWith: 'または、メールアドレスでサインインする',
    emailOrPasswordErrorMessage:
      '入力されたメールアドレスまたはパスワードが正しくありません。もう一度お試しください、または',
    resetPassword: 'パスワードをお忘れですか？',
    advantages: ['テストを購入する', '模擬テストを受ける', '結果を見る', 'ベストスコアを共有する'],
    dontHaveAccountYet: 'まだアカウントがありませんか?!'
  },
  startYourLanguageJourneyHere: '言語を学ぶ旅がここから始まります',
  join: '参加する',
  signInText: 'サインイン',
  thisIsRequired: 'このフィールドは必須です',
  invalidEmail: '無効なEメールアドレス',
  email: 'Eメール',
  fieldIsRequired: 'このフィールドは必須です',
  password: 'パスワード',
  signUpText: '登録する',
  createAnAccount: 'アカウントを作成する',
  watchTheVideo: '紹介ビデオを見る',
  resetPassword: {
    oldPasswordNotMatch: '古いパスワードが一致しません。',
    sameOldPassword: '新しいパスワードと古いパスワードは同じであってはなりません。',
    chooseAnotherPassword: 'パスワードはすでに使用されています。別のパスワードを選択してください。',
    header: 'パスワードをリセットする',
    sendLink: 'リンクを送信する',
    rememberedPassword: 'パスワードを思い出しましたか？',
    checkYourEmail: '良かったです！それでは、Eメールをご確認ください',
    sentLinkMessage:
      'パスワードをリセットするためのメールを送りました。アカウントにアクセスするため、リンクから新しいパスワードを作成してください。',
    signUpFirst: 'メールを受け取れない場合は、 まず<a>登録</a> をお願いいたします。',
    backToSignIn: 'サインインに戻る',
    notToWorryText:
      'ご心配なく。よくあることです！下記のフィールドにメールアドレスを入力してください。パスワードリセットのリンクを送信します。',
    nCharacters: '{{n}} 字',
    confirmPassword: '確認用パスワード',
    passwordsMustBeEqual: 'パスワードと確認用パスワードが一致しなければなりません',
    updatePassword: 'パスワードを更新する',
    passwordHasBeenUpdated: 'パスワードが更新されました！',
    signInToAccount:
      '下記のEメールと新しいパスワードでアカウントにサインインすると、テスト、スコア、プロフィールにアクセスできます。',
    createNewPassword: '新しいパスワードを作成する',
    settingNewPasswordDescription:
      '下記のフィールドで新しいパスワードを作成し、アカウントに進むことができます。'
  },
  atLeast: '少なくとも',
  oneLowercaseLetter: 'アルファベットの小文字１文字',
  oneUppercaseLetter: 'アルファベットの大文字１文字',
  oneNumber: '数字１文字',
  specialCharacter: '特殊文字１文字',
  tellUsMoreForm: {
    getToKnowYou: 'あなたについて',
    tellUsMore: '下記の項目に、ご入力ください',
    preferredName: '希望するお名前',
    fieldRequired: 'このフィールドは必須です',
    age: '年齢',
    country: '居住する国',
    city: '居住する町',
    next: '次へ',
    describe: '次のどれがあなたを最もよく表していますか？',
    done: 'これで完了です。ありがとうございました！',
    getReady: ' 準備しましょう',
    iAmStudent: '高等専門学校生・専門学校生・短期大学生・大学生',
    iAmGraduate: '私は大学院生です',
    iAmYoungProfessional: '私は若手の会社員です',
    iAmProfessional: '私は中堅・シニアキャリアの会社員です',
    iAmSecondaryStudent: '私は高校生です'
  },
  and: 'そして',
  changePassword: {
    alreadyUsedPasswordError:
      'パスワードはすでに使用されています。別のパスワードを選択してください。',
    oldPasswordDoesntMatchError: '古いパスワードが一致しません。',
    oldAndNewPasswordsAreEqualError: '新しいパスワードと古いパスワードは同じであってはなりません。',
    confirmPasswordError: '確認したパスワードと新しいパスワードが同じではありません。',
    youCanNowCreate: `下記のフィールドで新しいパスワードを作成できます。`,
    oldPassword: '古いパスワード',
    newPassword: '新しいパスワード',
    confirmPassword: 'パスワードを確認する',
    resetYourPassword: 'パスワードをリセットする',
    save: '保存する',
    success: '成功！',
    passwordChanged: 'パスワードの変更に成功しました。',
    forgotYourPassword:
      'パスワードをお忘れですか？ご心配なく。よくあることです！下記のフィールドにメールアドレスを入力してください。パスワードリセットのリンクを送信します。',
    sendLink: 'リンクを送信する',
    email: 'Eメール',
    checkEmail: '良かったです！それでは、Eメールをご確認ください',
    weHaveSentLink:
      'パスワードのリセット用リンクを送信しました。メール内のリンクから新しいパスワードを設定し、アカウントにアクセスしてください'
  },
  exploreTestsPage: {
    exploreResources: '受験の準備をする',
    exploreResourcesButton: '役立つリソース',
    watchOurWalkthroughs:
      'ステップバイステップのビデオを見たり、システム要件を確認したり、よくある質問を参照したりすることができます。',
    englishSkillsCertificate: 'English Skills Certificate - 4 Skills',
    listeningAndSpeaking: 'Speaking & Listening',
    readingAndWriting: 'Reading & Writing',
    practiceForFree: '無償の模擬テスト',
    buyNow: '申し込む',
    checkYourTest: '受験前のチェックリスト',
    takeTest: '用意するもの',
    chooseYourTest: 'Versant by Pearson',
    tagsAll: ['スピーキング', 'リスニング', 'リーディング', 'ライティング'],
    tagsListeningSpeaking: ['スピーキング', 'リスニング'],
    tagsReadingSpeaking: ['リーディング', 'ライティング'],
    ourEnglishSkillsCertificate: `<bold>{{productName}}™</bold>は、証明したい英語スキルのみを選択して受験することができます。`,
    exploreTestsWrapperTypeOfTestsHeader: '４つのスキルすべての英語力を測ります',
    forSuccessfulTest: '受験に際し、万全を期しましょう！ここでは、テストの要件をご紹介します',
    checkSystemReq: 'システム要件の確認',
    twoSkillsTests: '２つのスキルの英語力を測ります',
    requirements: {
      system: 'システム',
      checkYourSetUp: 'を行うことができます。',
      quickSystemCheck: 'クイックシステムチェック',
      windowOrMacComp: 'WindowsまたはMacコンピュータ',
      speakerOrMicrophone: 'スピーカーとマイク',
      reliableInternet: '信頼性の高いインターネット',
      security: 'セキュリティ',
      governmentId: '政府のID - パスポートまたは運転免許証が望ましい',
      singleMonitor:
        '1台のモニターまたはディスプレイ - 余分なディスプレイは無効しておく必要があります。',
      frontFacingCamera: '前面カメラ',
      environment: '環境',
      sixtyMinutes: '最大60分。受験するテストの種類によって異なります',
      quietWellLit: '明るい空間',
      privateSpaceWith: 'プライバシー - 一人で邪魔されないようにする必要があります。'
    },
    min: '分'
  },
  languageSwitcher: {
    ENG: '英語',
    JPN: '日本語',
    english: '英語',
    japanese: '日本語',
    KOR: 'KO',
    korean: '韓国語'
  },
  takenOn: '受験日',
  validThrough: '有効期限',
  homePage: {
    cta: {
      text: 'Certify your English skills now',
      describe:
        'テストは最大1時間です。いつでも受験可能で、結果を数分で希望の団体や企業と共有できます'
    },
    ctaFlexible: {
      text: 'フレキシブルでお手頃な価格のテスト',
      describe:
        '3つのオプションがあり、証明したい英語スキルのみを選んで受験できます。価格も、複数回受けやすく設定しています'
    },
    ctaMyTopScore: {
      text: 'myTopScore（自己最高スコア）',
      describe:
        'myTopScore（自己最高スコア）機能で、最高得点をアピールできます。テストを何回か受験いただくと、リーディング、ライティング、スピーキング、リスニングの各コアスキルから最も良い結果が自動的に選択されます。あなたの最も良い結果をもとに、最高スコアを計算し、周囲に差をつけることができます'
    },
    ctaShowYourCredly: {
      text: 'Credlyデジタルバッジで自信を持ってアピールしましょう',
      describe:
        'Credlyの公式デジタルバッジで、英語力のスコアをアピールできます。Credlyバッジを履歴書、電子メールの署名、ソーシャルメディアのプロフィール、オンラインポートフォリオに加えるだけで、実践的な英語のスキルを証明できます。'
    },
    enterYourEmail: 'メールアドレスを入力',
    exploreTests: 'テストの詳細',
    discoverCredly: 'Credlyの詳細',
    exploreResources: 'リソースをチェック',
    learnAboutTopscore: 'myTopScoreを詳しく見る',
    pearsonTestsAreTrusted: 'Pearsonのテストは、主要な教育機関や企業の信頼を得ています',
    fasterWayToShowEmployers: 'どこよりも速く英語力を証明できます',
    featuresOfProduct: {
      fastTitle: '迅速さ',
      fastDescription: 'テスト結果が数分でわかり、48時間以内に認定スコアを企業と共有できます',
      convenientTitle: '利便性',
      convenientDescription:
        'いつでもどこでもオンラインで受験でき、試験会場への移動や予約が不要です',
      authenticTitle: '信頼性',
      authenticDescription:
        'テストに合格する能力ではなく、実際に使える自然な英語コミュニケーション能力を企業に示すことができます'
    }
  },
  allRightsReserved: '© 2023 Pearson 無断転載を禁じます。',
  footerLinks: {
    termsOfUse: '利用規約',
    privacy: '個人情報',
    cookies: 'Cookies'
  },
  generatedOn: '作成日',
  shareOnCredly: 'あなたのCredlyバッジ',
  skillsLabel: 'Skills',
  myOverallProficiency: '全体的な英語運用能力',
  gseScore: '全体スコア',
  cefrScore: 'CEFR',
  profilePage: {
    automaticShareInfoTooltip:
      'テストがアクティベーションコードに基づいていたため、これらのスコアは、教育機関と自動的に共有されました',
    jitNotice: 'テストは開始されており、返金できません。',
    downloadReceipt: 'レシピをダウンロード',
    denied: '拒否',
    error: 'エラー',
    close: '閉じる',
    profileTab: 'プロフィール',
    orderHistoryTab: '購入履歴',
    sharedScoresTab: '共有中のスコア',
    searchPlaceholder: '検索',
    allSentScores: '送信した全スコア',
    backToAllSentScores: '送信した全スコアへ戻る',
    turnSharingOff: '共有をオフにする',
    shareDetailsTooltipTitle:
      '同意を取り消すと、これまでスコアへのアクセスリンクが記載されていたすべてのEメールから、証明書を閲覧することができなくなります。この操作は取り消しできません。',
    scoreNotAvailable: '当初スコアを共有していたメール受信者が、スコアにアクセスできなくなります',
    scoresTableHeaders: ['組織名', 'Eメール', '共有日', 'ステータス'],
    dateShared: '共有日',
    email: 'Eメール',
    allOrderHistoryTableHeaders: ['注文番号', '購入日', '注文状況', '合計', ' '],
    allOrderHistoryTableHeadersShortcut: ['注文番号', '', '', '合計'],
    allSentScoresTableHeaders: ['テスト名', 'テストID', 'スコア', '生成日', '共有者'],
    viewed: '閲覧済み',
    notViewed: '未閲覧',
    dontHaveAnyHistoryOrders: '購入履歴がありません',
    requestRefund: 'キャンセルする',
    processingOrder: 'オーダーを処理しています...',
    youAreAllSet: '返金手続きを開始しました',
    noLongerRefundable: 'このテストは払い戻しできません。',
    noAvailableTestsForRefund: '現在返金の対象となるテストはありません',
    testsAlreadyRefundedDescription: 'この注文はすでに返金された',
    refundInProgressTitle: '他にも返金をご希望ですか？',
    refundInProgressDescription:
      'こちらの注文につきましては、前回の返金処理が終了するまでお待ちください。',
    testsExpiredForRefundDescription:
      '返金をご希望のテストは受験済みもしくは有効期限が切れています。',
    cannotRequestARefund:
      'ご購入から90日以上経過している場合、またはすでにテストを開始している場合は、返金の対象とはなりません。',
    requestARefund: 'キャンセルする',
    weHaveInitiatedYourRefund:
      '金融機関によって所要日数は異なりますが、10日前後でテストを購入した口座に振り込まれます。',
    selectProducts: 'キャンセルして返金を希望する商品を選択してください',
    paid: '支払済み',
    fulfilled: '決済完了',
    refunded: '返金済み',
    partiallyRefunded: '一部返金済み',
    pending: '処理中',
    done: '完了',
    refund: 'キャンセル',
    titleAllOrders: 'すべての注文',
    recentOrders: '最近のオーダー',
    accordionHeaders: ['商品名', '数量', '価格', ' '],
    accordionHeadersShortcut: ['アイテム', '価格'],
    refundPopupHeaders: ['アイテム', '購入日', '価格'],
    basicInformation: '基本情報',
    edit: '編集',
    demographicDetails: '受験者の詳細',
    fullName: 'お名前',
    dateOfBirth: '生年月日',
    gender: '性別',
    countryOfResidence: '居住する国',
    cityOfResidence: '居住する市',
    citizenship: '国籍',
    languages: '言語',
    securityAndPrivacy: 'セキュリティとプライバシー',
    managePasswordHeader: 'パスワードを管理する',
    managePasswordText: 'パスワードを変更する',
    privacyPolicyHeader: '個人情報保護方針',
    privacyPolicyText: 'Pearsonオンライン個人情報保護方針を見る',
    termsOfUseHeader: '利用規約',
    termsOfUseText: 'Pearsonオンライン商品利用規約を見る',
    editProfileTitle: 'プロフィール情報を入力する',
    changeYourPassword: 'パスワードを変更する',
    editProfileWebTips:
      '<p><bold> 名前：</bold>IDに記載されているファーストネーム、ミドルネーム、その他の名前を入力してください。</p> <p><bold>苗字：</bold> ID記載されている苗字を正確に入力してください。</p>',
    editProfileFormDescription:
      'テストを受けるには有効な写真付き身分証明書（ID）が必要です。IDに記載されている氏名が英語でなくても大丈夫です。IDに書かれている言語で入力してください。',
    editProfileFormGivenName: '名前',
    editProfileFormGivenNameTooltip:
      '政府発行の身分証明書と名前が一致していることを必ず確認してください。',
    editProfileFormSurname: '苗字',
    editProfileFormSurnameTooltip:
      '政府発行の身分証明書と姓が一致していることを必ず確認してください。',
    countryOfCitizenship: '国籍',
    countryOfCitizenshipTooltip:
      'なお、国籍は受験時に提出するIDに記載されている国籍と必ず一致していなければなりません。',
    startTypingPlaceholder: '入力を始める...',
    editProfileFormEmail: 'Email アドレス',
    next: '次へ',
    firstLanguage: '第一言語',
    scoreSharingHeader: 'スコア共有の詳細',
    sharedWithPeople_zero: '0名',
    sharedWithPeople_one: '1名',
    sharedWithPeople_other: '{{count}} 名'
  },
  noOptions: '選択肢がありません',
  english4SkillsTestName: 'English Certificate | 4-Skills',
  myTopScoreSeparated: 'My Top Score',
  yourTopScoreIsCalculatedFrom:
    '<boldItalic>myTopScore</boldItalic>は、各スキルの最も高いスコアから算出されます。 これまでの受験の自分のベストスコアを確認してみましょう！',
  dashboardPage: {
    backToDashboard: 'ダッシュボードに戻る',
    noScore: 'スコアなし',
    welcome: 'ようこそ <highlight>{{name}}</highlight>',
    welcomeTitle: 'ようこそ {{name}}',
    welcomeBack: 'おかえり<highlight>{{name}}</highlight>',
    welcomeBackTitle: 'おかえり{{name}}!',
    headerText: '<bold>英語スキルの認定</bold>を取得するまであと少しです!',
    beforeStartModalSubtitle: '無償で模擬試験を受ける',
    beforeStartModalTitle: '始める前に',
    beforeStartModalText: 'テストを受けること、する必要があるのは次のとおりです。',
    beforeStartModalTextPractice: '模擬試験を受けるためのステップは次のとおりです',
    beforeStartModalText2:
      '準備はできましたか？コンピューターに、テスト用アプリケーションをダウンロードしてインストールします。',
    beforeStartModalListItem1: 'テスト用アプリケーションをダウンロードする<bold>（2分）</bold>',
    beforeStartModalListItem2: 'テスト環境をセットアップする<bold>（2分）</bold>',
    beforeStartModalListItem3: 'テストを受ける<bold>（30～60分）</bold>',
    beforeStartModalListItemPractice3: '模擬試験を受ける<bold>（15～30分）</bold>',
    retakeTestButton: '再試験',
    finalParagraph:
      '準備はいいですか？コンピュータを使ってテストアプリケーションをダウンロードし、インストールしてください',
    finalParagraphProductName:
      '準備はいいですか？コンピュータから<bold>{{productName}}</bold>アプリケーションをダウンロードしてインストールしてください。',
    beforeStartModalButton: 'ダウンロード',
    retake: 'リテイク',
    SoftProfileAllDoneText:
      'テストを受けるには、<bold>English Certificate</bold>アプリをデスクトップにダウンロードする必要があります。',
    SoftProfileAllDoneButton: 'ダッシュボードに行く',
    getReady: '準備する',
    youAreAllDone: 'もう終わりですね、ありがとうございます！',
    accordionTitle: '英語テストを購入する',
    accordionSubtitle: 'あなたが証明したいスキルの認定を受ける',
    accordionPracticeTitle: '無料で模擬テストを受ける',
    accordionPracticeSubtitle: '',
    accordionTakeTestTitle: 'テストを受ける',
    accordionTakeTestButtonText: 'テスト開始',
    accordionLatestTestResult: '最新のテスト：<span>{{score}}</span>',
    accordionShareResultsTitle: '結果を共有する',
    accordionShareResultsSubtitle: 'あなたの結果を組織や企業に送り、Credlyバッジを共有する ',
    accordionLatestTestTitle: '結果を見る',
    badgeMyTopScore: 'MyTopScore',
    badgeValidThrough: '有効期限：<bold>{{date}}まで</bold>',
    badgeViewDetails: '詳細を見る',
    badgeNoTopScoreText:
      'あなたの<bold>MyTopScore</bold>は、各スキルのトップスコアから算出されます。ここでベストスコアを確認するためにテストを受けてみてください！',
    credlyBadgeTitle: 'Credlyバッジを受け取る',
    credlyBadgeTitleRedeemed: 'Share your Credly badge',
    credlyBadgeLi1: 'Credlyから送られたEメールを確認します',
    credlyBadgeLi2:
      'Eメール内のリンクを使用して、Credlyのプロフィールを作成し、バッジを受け取ります',
    credlyBadgeLi3: 'バッジを共有して、あなたのスキルをみんなに知らせてください！',
    credlyBadgeButtonRedeemed: 'Credlyへ移動します。',
    credlyBadgeButton: 'Credlyについてもっと知る',
    credlyBadgeRedeemedCongratulationsText: 'おめでとうございます。Credlyバッジを取得しました。',
    credlyBadgeRedeemedCongratulationsTextLine2:
      'これでバッジを共有できます。Credlyプロフィールを完成させるところから始めましょう',
    credlyBadgeTaketestToGetCredly:
      'テストを受けてCredlyバッジを取得しましょう！希望の連絡先と共有できます。',
    takeTestAccordionNoTestsText: 'テストを購入して英語力を証明する',
    takeTestAccordionAvailableTestsTitle: '利用可能なテスト <span>{{availableTests}}テスト</span>',
    takeTestAccordionSignInButton: 'テストを受ける',
    formDownloadAccordionTitle: '始める前に',
    formDownloadAccordionPracticeSubtitle: '無料で練習ができる',
    formDownloadAccordionSubtitle: 'テストを受ける',
    startJourneyStepperTitle: '始める方法はこちら',
    startJourneyStepperStep1Description: 'テストアプリケーションのダウンロード',
    startJourneyStepperStep2Description: ' テスト環境をセットアップする',
    startJourneyStepperTimeRequired: '{{time}}分',
    startJourneyStepperStep3Description: '本人確認',
    startJourneyStepperStep4Description: 'テストを開始する',
    latestTestBoxTitle: '最新テスト',
    fourSkillsTestTitle: 'English 4 Skills Test',
    practiceSubtitle: '無料で練習ができる',
    practiceTitle: '始める前に',
    speakingAndListeningTestTitle: 'Speaking & Listening Test',
    readingAndWritingTestTitle: 'Reading & Writing Test',
    whatsNextTile: {
      startTest: 'テストを受ける',
      whatYouCanDoNext: '次にできることは：',
      takePracticeTest: '模擬テストを受ける',
      buyATest: 'テストを購入する',
      viewResults: '結果を見る',
      shareResults: '結果を共有する',
      redeemCode:
        'アクティベーションコードを入手しましたか？ <action>テストを起動させましょう</action>'
    },
    min: '分',
    welcomeDialogPopupTitle: `{{productName}}にようこそ`,
    resultsAccordionTableHeaders: ['テスト', '日付', 'ステータス', '全体スコア', 'CEFR', ''],
    practiceTestLabelButtonText: '模擬テストを開始',
    productTileButtonText: '準備完了',
    identifyIntroSection: {
      whatYouNeed: 'このセクションで必要なもの',
      yourId: 'あなたのID',
      governmentId: '顔写真を含む政府発行のIDであること。IDの有効期限は3ヶ月以上必要です。',
      mobilePhone: '携帯電話 - 推奨',
      weRecommend:
        '携帯電話からIDを撮影しておくことをお勧めします。携帯電話が手元にない場合でも、パソコンのウェブカメラを使ってアップロードを完了することができます。',
      nextPage: '次のページ'
    },
    practiceTestList: {
      errorMessage: '利用可能な模擬試験の取得に問題がありました'
    },
    resultTestPanel: {
      errorMessage: 'お客様のテスト結果を取得する際に問題が発生しました'
    },
    backToAllResults: '全結果に戻る',
    shareScoresDownloadCertificate: 'スコアの共有／賞状のダウンロード',
    startTest: 'テスト開始',
    downloadScoreCard: 'スコアカードをダウンロードする',
    buyTest: 'テストを購入する',
    productTileCounter: '{{items}}項目',
    seeAllResults: 'すべての結果を見る',
    redeemActivationCodeTile: {
      text: '<bold>アクティベーションコード</bold>をお持ちですか？テストを開始するには、以下を使用してください。',
      buttonText: 'テストを開始する'
    }
  },
  helpCenterPage: {
    header: '受験のサポート',
    headerText:
      '{{productName}} テストを最大限活用できるよう、私たちがお手伝いできることをご紹介します。',
    sidebarText:
      '他に質問はありますか？お手伝いが必要な場合は、いつでも<a>お問い合わせ</a>ください。',
    activeCategory: 'テストについて'
  },
  survey: {
    caption1: 'ひどい',
    caption2: 'あまり良くない',
    caption3: '良い',
    caption4: '偉大な！',
    caption5: '傑出している！',
    subheader: 'お出かけ前に',
    header: 'あなたの経験を評価する',
    headerAlternative: 'ご意見ありがとう！',
    subheader2: 'あなたのテスト体験をお聞かせください',
    textFieldLabel: 'もっと教えて',
    button: '送信',
    buttonAlternative: 'ダッシュボードへ',
    reason: {
      subheader: 'フィードバックをお寄せください',
      header: 'ページを閉じる前に',
      subheader2: '何が起きたか教えてください：',
      textFieldLabel: `その他にご意見・ご要望がありましたらお知らせください`
    },
    leaveOnEnvSetup: {
      reason1: 'テストのセットアップに問題があった',
      reason2: '今はテストを受ける時間がない'
    },
    leaveOnIDVerification: {
      reason1: 'ID認証に問題があった',
      reason2: '今はテストを受ける時間がない'
    }
  },
  dateGenerated: '生成日',
  sharedWith: '共有者',
  testCode: 'テストコード',
  testTakerId: '受験者ID',
  stopSharing: '共有を停止する',
  allSharedScores: '共有した全スコア',
  doYouWantStopSharing:
    '<bold>MyTopScore（自己最高スコア）</bold>の共有を停止します。登録した共有相手がスコアにアクセスできなくなります。この操作は取り消すことができません',
  orderConfirmation: {
    thanksForPurchase: 'ご購入、ありがとうございます！',
    yourOrderNumberIs: 'ご注文番号は<bold>{{orderNumber}}</bold>です。',
    weHaveSentYouConfirmationEmail:
      'ご注文に関するご質問は、<a>こちらのフォーム</a>よりご連絡ください。',
    fromDashboardYouCan: 'ダッシュボードから次のことができます',
    viewOrderHistory: '購入履歴を見る - アカウントページで、「購入履歴」を選択します',
    takeATest:
      'テストを受ける - 購入したテストがすぐに表示されない場合は、ページを再読み込みしてください',
    goToDashboard: 'ダッシュボード',
    viewOrderHistoryButton: '購入履歴',
    errorTitle: 'Oops!',
    errorMessage: '間違ったリンクをクリックしたようです。再度お試しください。'
  },
  processingOrderBanner: {
    description: '注文を処理中です。しばらくしてから再度購入内容をご確認ください。',
    orderId: '注文ID：',
    dateOfPurchase: '購入日：'
  },
  gettingReadyPage: {
    heroHeader: 'あなたの英語力を輝かせるために必要なもの',
    heroText: '受験準備に役立つ無償のリソースをご活用ください。',
    heroPracticeButtonText: '模擬テストを受ける',
    heroDownloadButtonText: 'ガイドをダウンロードする',
    getStartedHeader: '受験の流れ',
    getStartedText: 'テストの各ステージへのステップバイステップガイドです。',
    getStarted1Title: '準備する',
    getStarted1Link: '受験の準備をする',
    getStarted1Points: [
      '無料アカウントを作成する',
      'テストアプリをパソコンにダウンロードする',
      '模擬テストは何度でも無償で受けられます',
      'テストガイドを読む'
    ],
    getStarted2Title: 'テストを受ける',
    getStarted2Link: 'チェック要件',
    getStarted2Points: [
      'テストを購入する',
      '準備ができたらテストアプリを起動させます',
      '受験に必要なセットアップとIDのチェックをします',
      '準備が整いました！テスト終了まで1時間程度必要です'
    ],
    getStarted3Title: 'テストを終えてから',
    getStarted3Link: '結果について詳しく見る',
    getStarted3Points: [
      '48時間以内に検証された結果を得る',
      '潜在的な雇用者にCertificateを共有する',
      'Credlyバッジの受取りと共有'
    ],
    howToHeader: '動画でハウツーガイドもご覧いただけます',
    howToVideo1Title: 'テストに向けて準備する',
    howToVideo1Subtitle:
      'テストの申し込み方法、準備、テスト用アプリケーションのダウンロードを確認する。',
    howToVideo2Title: 'テストを受ける',
    howToVideo2Subtitle: 'テストの開始方法、機器の確認方法、IDの確認方法をご紹介します。',
    howToVideo3Title: '結果を理解する',
    howToVideo3Subtitle: '自分のスコア、証明書、MyTopScore™ を理解する。',
    howToVideo4Title: '結果を共有する',
    howToVideo4Subtitle: '企業や機関などへの証明書の共有方法について学ぶ',
    prepareForTestHeader: 'テストに向けた準備',
    prepareForTestLeftHeader: '模擬テスト',
    prepareForTestLeftText:
      'スコアを上げる最善の方法は繰り返し模擬試験を受けることです。この模擬試験はいつでも何度でも受けることが可能です。',
    prepareForTestLeftButton: '無料の模擬テストを受ける',
    prepareForTestRightHeader:
      'テストの説明に加え、準備、セットアップのガイダンス、採点、結果の共有についてのガイドです。無償でダウンロードできます。',
    prepareForTestRightText:
      'テストそのものに加え、準備、セットアップガイダンス、採点、共有のための究極のガイドです。無料でダウンロード可能です。',
    prepareForTestRightButton: 'テストガイドをダウンロードする',
    exploreTestHeader: '問題形式の種類について学ぶ',
    exploreTestText: '問題形式の種類とそれぞれの問題への対応の仕方を学ぶ。',
    exploreTestVideo1title: 'English Certificate | 4-Skills',
    exploreTestVideo1Description: 'English 4-Skills Testテストのビデオウォークスルー',
    exploreTestVideo2title: 'English Certificate | Speaking & Listening',
    exploreTestVideo2Description: 'English Speaking & Listening Testテストのビデオウォークスルー',
    exploreTestVideo3title: 'English Certificate | Reading & Writing',
    exploreTestVideo3Description: 'English Reading & Writing Testテストのビデオウォークスルー',
    systemRequirementsHeader: 'システム要件を確認する',
    systemRequirementsText:
      '中断することなくテストを進められる要件が全て揃っていることを受験前に必ず確認してください。',
    systemRequirementsItem1Title: 'システム',
    systemRequirementsItem1Line1: 'WindowsまたはMacコンピュータ',
    systemRequirementsItem1Line2: 'スピーカーまたはマイク',
    systemRequirementsItem1Line3: '信頼性の高いインターネット',
    systemRequirementsItem2Title: 'セキュリティ',
    systemRequirementsItem2Line1: '政府発行の身分証明書 - パスポートまたは運転免許証が望ましい',
    systemRequirementsItem2Line2:
      'シングルモニター - デュアルスクリーンの設定は無効にしておく必要があります',
    systemRequirementsItem2Line3: '前面カメラ',
    systemRequirementsItem3Title: '環境',
    systemRequirementsItem3Line1: 'テスト開始から60分間中断できません',
    systemRequirementsItem3Line2: '明るい空間',
    systemRequirementsItem3Line3: '誰もいないプライベートな空間',
    resultsHeader: '結果の確認と共有',
    resultsText:
      '当社は48時間以内にあなたのスコアを証明することをお約束します。この時間の中で、あなたのテスト結果が当社のセキュリティ要件を満たしているか確認します。この認証ポリシーについてはFAQや公式ガイドで内容をご確認ください。',
    resultsItem1Title: '1時間以内',
    resultsItem1Subtitle: 'スコアを見る',
    resultsItem1Description:
      '最終的なセキュリティチェックに先立ち、あなたの仮のスコアを共有します。',
    resultsItem2Title: '48時間以内',
    resultsItem2Subtitle: 'スコア証明書を入手する',
    resultsItem2Description:
      'セキュリティチェックが完了したら、すぐにお知らせします。テストが当社のセキュリティ要件を満たしている場合、証明書はスコアダッシュボードに表示されます。',
    resultsItem3Title: '準備完了',
    resultsItem3Subtitle: '結果を共有する',
    resultsItem3Description:
      'スコアダッシュボードで企業などと直接スコアを共有したり、CertificateをPDFでダウンロードしたりすることができます。また、4スキルすべてで認定を受けると、Credlyバッジを利用できます。',
    resultsTitle2: 'MyTopScoreを活用しましょう',
    resultsText2:
      'あなたの最高得点を確実にアピールします。証明書には、過去 6 か月間のスピーキング、リスニング、リーディング、ライティングの最高スコアが自動的に表示されます。自信を持ってスコアを共有しましょう',
    resultsTitle3: 'Credlyバッジで輝こう',
    resultsText3:
      'MyTopScoreごとに、世界的に認知されたデジタルCredlyバッジを取得し、達成を共有し祝うことができます。履歴書に追加したり、ソーシャルメディアで共有したりでき、あなたの英語能力がいろいろな人の目に触れる機会を増やします。',
    resultsButton: 'Credlyの詳細を確認する',
    faqHeader: 'FAQ',
    faqReadMore: '受験のサポート',
    downloadDialogSubtitle: 'テストレディ',
    downloadDialogTitle: 'テスト受験者ガイドをダウンロードする',
    startTestDialogSubtitle: '始める前に',
    startTestDialogTitle: 'いくつか注意点があります...。',
    startTestDialogParagraph1:
      '模擬テストを受けるには、いくつかのステップを完了する必要があります：',
    startTestDialogLi1: 'アカウントを作成する',
    startTestDialogLi2: 'テスト用アプリをダウンロードする',
    startTestDialogParagraph2: '模擬テストには、以下のものが必要です：',
    startTestDialogLi3: 'コンピュータ（PCまたはMac)',
    startTestDialogLi4: '前面カメラ',
    startTestDialogButtonClose: '閉じる',
    startTestDialogButtonContinue: '続ける',
    downloadPopupTitle: 'ダウンロードアプリケーション',
    downloadPopupSubtitle: '準備しましょう',
    formDownloadTitle: 'テストを受ける',
    faqIAccordion1Title: '認証システムで使えるIDはどれですか？',
    faqIAccordion1Description:
      'テストの前に、以下の要件を満たす身分証明書（ID）を提出する必要があります：',
    faqIAccordion1List1: [
      'すべてのIDは、政府発行の有効な原本でなければなりません（コピーではありません）',
      '身分証明書は受験者の名前と最近撮影された写真であること',
      'IDに記載されている姓と名は、プロフィール情報で登録した姓と名と一致している必要があります。',
      '有効期限切れの書類は受け付けられません'
    ],
    faqIAccordion1Description2: '使用可能な身分証明書',
    faqIAccordion1List2: [
      '国際旅行用パスポート',
      '運転免許証',
      '身分証明書（国、州、県のIDカード）',
      '外国人登録証（グリーンカードまたは永住権・ビザ）'
    ],
    faqIAccordion1Description3: '容認できないIDの形態',
    faqIAccordion1List3: [
      '米国国防総省（DoD）共通アクセスカード（CAC）または特定のセキュアアクセスIDを含む、制限付きID*の場合',
      '{{productName}} が制限されている国からのID： 北朝鮮、キューバ、シリア、スーダン、イラン、ロシア、ベラルーシ、ウクライナのセヴァストポリ/クリミア地域'
    ],
    faqIAccordion1Description4: `*{{productName}}では、オンラインテストの身分証明書として、制限付きID（法律でコピー、デジタル化、カメラで撮影することが禁止されているもの）を受け付けることはできません。`,
    faqIAccordion2Title: 'プロクターリング・ウィンドウとは何ですか？',
    faqIAccordion2Description:
      '試験中、私たちの試験監督システムは、あなたの行動を分析し、不正行為や疑わしい行為がないことを確認します。テスト結果の認定を受けるためには、当社のプロクターリング・ルールに従っていただくことが不可欠です。',
    faqIAccordion2Description2: '以下、覚えておいていただきたい推奨事項です。',
    faqIAccordion2List1: [
      '周囲の雑音がない静かな環境で受験してください。',
      '明るい場所でテストを受ける',
      'テストの間、一人であることを確認すること'
    ],
    faqIAccordion2Description3: 'IDについて',
    faqIAccordion2Description4: 'FAQの「身分証明書として認められるもの」に詳細が記載されています。',
    faqIAccordion2List2: [
      'アカウントの詳細（名前、姓など）は、政府発行のIDカードの情報と一致する必要があります。',
      '他人の個人情報やIDを使用しないでください。'
    ],
    faqIAccordion3Title: '私のテストが「審査中」と表示されます。これは何を意味するのでしょうか？',
    faqIAccordion3Description:
      'これは、あなたのテストセッションが現在、人間のレビュアーによって分析されていることを意味します。レビューの結果に応じて、テストはダッシュボードに「Certified」または「Unable to certify」のどちらかで表示されます。',
    faqIAccordion3Description2:
      '当社のセキュリティレビューが完了次第、電子メールでお知らせします。私たちは、お客様がテストを完了してから48時間以内にこれを完了することを約束します。テストが「Certified」と表示された場合、お好きなだけ多くの組織と証明書を閲覧、ダウンロード、または直接<bold>分け合う</bold>することができます。',
    formDownloadText:
      'なお、テストを受けるには、デスクトップに<bold>英語技能検定アプリ</bold>をダウンロードする必要があります。',
    formDownloadClose: '閉じる'
  },
  footerGetInTouchHeader: 'お問い合わせはこちら',
  footerGetInTouchText: '頼もしいスタッフが質問にお答えます。',
  footerGetInTouchButton: 'お問い合わせ',
  welcomePopup: {
    subtitle: 'ようこそ',
    mainTitle: `{{productName}}にようこそ`,
    title: 'こちらはあなたのダッシュボードです。本番テストに向けて、頑張りましょう。',
    button: '完了',
    takeATest: 'テストを受ける'
  },
  signInPage: {
    haveAccount: '既にアカウントをお持ちのようです。',
    enterPassword: 'パスワードを入力して続ける。'
  },
  scoreLookup: {
    expiredDescription:
      'リンクの有効期限が切れたため、スコアにアクセスできなくなりました。受験者に連絡して、新しいリンクをリクエストしてください。',
    supportLink: 'お困りの場合は、<a>サポートページ</a>の詳細をご覧ください。',
    expiredButton: 'ホームページに戻る',
    lookup: '証明書の検索',
    description1: '証明書にアクセスするには、次の情報を入力してください。問題がある場合は、',
    description2: 'サポートページで',
    description3: ' 詳しい情報をご覧ください。',
    name: '受験者名',
    required: 'このフィールドは必須です',
    org: '組織名',
    country: '国名（任意）',
    consent:
      'このボックスをクリックすることで、私は受験者の証明書にアクセスする許可を得ていることを保証します。',
    viewCertificate: '証明書を見る',
    byClickingOn: 'クリックすることで',
    youAreAgreeing: '次のポリシーに同意したことになります',
    privacyPolicy: '個人情報保護方針',
    termisOfUse: '利用規約',
    cookiePolicy: 'クッキーに関するポリシー',
    tooltip: 'このデータは内部の報告目的でのみ使用します。'
  },
  mins: '分',
  'No score': 'スコアなし',
  mobileUploadId: {
    takeAPhoto: '身分証明書を照合するため、身分証明書の写真を撮ってください',
    toBegin:
      '身分証明書をしっかりとして光が十分に当たるところに置いて、フレームの中に合わせてください。フレームの中に照準があったら写真を撮ってください。',
    takePicture: '写真を撮ってください',
    takeAPhotoBack:
      '身分証明書の前面の写真送付をありがとうございます。裏面も送る必要がある場合には、空白のフレームをクリックしてください。',
    frontAccepted: '身分証明書の前面部分が記録されました',
    important: '重要',
    importantInfo:
      'カード形式の身分証明書は前面と裏面の両方が必要となります。パスポートの場合は、一つの画像で十分です。',
    frontOfId: '身分証明書の前面',
    use: '利用する',
    tryAgain: '再度試す',
    retry: '再度試す',
    tapToContinue:
      '身分証明書の裏面を提出する場合にはフレームをクリックしてください。必要なければSkipをクリックして続けてください。',
    skip: '身分証明書の裏面の送付をSkipする',
    backCaptured: '身分証明書の裏面を記録しました',
    backOfId: '身分証明書の裏面',
    sessionExpired: '時間切れとなりました',
    outOfTime: '新しいQRコードの生成のため、{{productName}}のアプリケーションまで戻ってください',
    done: '終了しました',
    allDone: '全て終了しました',
    toContinue: 'テストを継続するために{{productName}}のアプリケーションまで戻ってください',
    thanksForCompleting:
      '全ての過程を終了くださりありがとうございます。このウィンドウは閉じることができます。',
    photoDidntMeetRequirements: '写真が当テストの要件に合いませんでした',
    pleaseTryAgain:
      '再度お試しください。ガイドラインを思い出しながら身分証明書の写真を撮影してください。',
    guidelines: '写真のガイドライン',
    cornersMissing: '角が欠けています',
    blurry: 'ぼやけています',
    covered: '覆われています',
    clear: '鮮明で詳細まで写されています',
    lineUp:
      '身分証明書をしっかりとして光が十分に当たるところに置いて、フレームの中に合わせてください。',
    errorHeader: '代わりにスマートフォンをご利用ください',
    errorDescription:
      'このページはウェブブラウザからはアクセスできません。身分証明書の提出のため、スマートフォンでQRコードをスキャンしてください。',
    useQrCode: '続けるには上のQRコードを携帯電話でスキャンしてください',
    alreadySubmittedTitle: '身分証明書が既に提出されています',
    alreadySubmittedDescription: 'こちらで全て終了となります。ありがとうございました。',
    linkOnlyValidFor:
      '身分証明書のアップロードリンクが有効なのは<bold>14 日</bold>です。  さらに助けが必要な場合には<a>サポートチーム</a> までご連絡ください。',
    timeLeftToSubmit: '身分証明書の提出の残り時間です',
    linkNotValidAnymore: 'このリンクは無効です'
  },
  skillsTile: {
    weWereUnable:
      'あなたのスコアを認証できませんでした。下記の<bold>自分のスコアを見る</bold>をクリックして、スコアの詳細をご覧ください。'
  },
  testTile: {
    weAreUnable:
      'テストが完了していないためスコアを出すことができません。無償での再受験をお願いいたします。',
    ifNeedHelp: 'ご質問は<a>お問い合わせ</a>までお寄せください。',
    testId: 'テストID',
    weCantProvide:
      'ルール違反があったためテスト結果を認証できません。ご質問は<a>お問い合わせ</a>までお寄せください。',
    dueToProblem:
      '申し訳ございません。不具合がありこのテストのスコアを判定することができません。無償にて再受験をお願いいたします。'
  },
  certificateTypes: {
    readingWriting: 'English Certificate | Reading & Writing',
    speakingListening: 'English Certificate Speaking & Listening'
  },
  availableTestsNotification: `あなたは<a>{{testsCount}}つのテスト</a>を利用できます。`,
  clickHereToSubmit:
    '身分証明書の裏面を提出する場合にはフレームをクリックしてください。必要なければSkipをクリックして続けてください。',
  webResultsSurvey: {
    firstPurchase: {
      title: '購入体験はいかがでしたか？',
      subtitle: 'テストをご購入いただきありがとうございました。体験を評価してください。'
    },
    certified: {
      upperTitle: 'フィードバックを共有する',
      title: 'テストはいかがでしたか？',
      subTitle: '証明書の取得おめでとうございます! {{productName}} の経験はどうでしたか?'
    },
    incomplete: {
      question1: {
        title: 'テストがどうのようであったか教えてもらえますか？',
        option1: 'テストを終わらせる気にならなかった',
        option2: '技術的な問題があった',
        option3: 'その他（以下の空欄にご記入ください'
      },
      question2: '他にご意見・ご要望がございましたら記入をお願いいたします',
      question3: {
        title: '5日以内に無償で再受験しますか？',
        option1: 'はい',
        option2: 'いいえ'
      }
    },
    uncertified: {
      subTitle: '残念ながらスコアを認定できませんでした。',
      scaleMinLabel: '強く同意',
      scaleMaxLabel: '強く反対',
      q1: '私はなぜテストが認定されなかったか理解しています',
      q2: '私はどうしたら受験環境を改善できるか理解しています',
      q3: '私はまたテストを受けようと思っています'
    }
  },
  limitReachedModal: {
    title: '上限に達しました',
    close: '閉じる'
  },
  policiesLinks: {
    termsOfUse: '利用規約',
    privacyPolicy: '個人情報保護方針'
  },
  activationCodePopup: {
    expiredMessage: 'アクティベーションコードの有効期限が切れました',
    title: 'テストを起動する',
    subtitle: 'テストを加える',
    description:
      '直販サイト以外でのご購入の場合、アクティベーションコードが送られて来ます。こちらのコードでいつでもテストを起動できます。一度起動させると、90日以内に受験する必要があります。',
    inputPlaceholder: 'アクティベーションコード ',
    buttonText: 'テストを起動する',
    tooltip:
      '<bold>アクティベーションコードが見つかりませんか？ </bold><br/> メールを確認し、見つからない場合には購入元に問い合わせてください ',
    skip: 'スキップする ',
    next: '次へ',
    validMessage: 'ご自身のアカウントにテストが表示されます',
    invalidMessage: 'このアクティベーションコードは無効です',
    usedMessage: 'このアクティベーションコードは使用済みです',
    tooManyAttempts: 'すみません。規定回数以上認証に失敗しました。時間をおいてお試しください。'
  },
  downloadCertificatePopup: {
    subtitle: '以下からダウンロードしたい言語を選択してください。',
    buttonText: 'ダウンロード',
    wrapperTitle: '証明書をダウンロードする',
    myTopScore: 'MYTOPSCORE',
    speakingListening: 'SPEAKING & LISTENING',
    readingWriting: 'READING & WRITING',
    languages: {
      eng: '英語',
      jpn: '日本語',
      kor: '韓国語'
    }
  },
  sharedScoresDetailedTable: {
    headers: ['テスト名', 'テストID', 'スコア', '共有者', '共有']
  },
  toast: {
    somethingWentWrong: 'Oops! Something went wrong. Please try again'
  },
  allScoresYouShared: '共有したすべてのスコア',
  pageNotFound: {
    title: '宇宙の中で迷子になったようです',
    description: 'お探しのページが見つかりません',
    button: 'ホームページに戻る'
  },
  orderHistory: {
    testWasFree: 'このテストは無料ですので、返金されません。',
    alreadyRefunded: 'この注文は返金されました',
    testAlreadyRefunded: 'このテストは返金されました'
  },
  oAuthFailed: {
    title: 'アカウントが存在しません',
    subtitle:
      '入力したメールでは、Versant English Certificateに既存のアカウントがありません。サインアップしてアカウントを作成してください。'
  }
};
